export default {
    "en": {
        "passwords": {
            "password": "Passwords must be at least six characters.",
            "reset": "Your password has been reset!",
            "sent": "We have e-mailed your password reset link!",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that e-mail address.",
            "spam": "If you don't see the e-mail, check your spam folder.",
            "check": "Please double check your e-mail address.",
            "checkemail": "Check Your Email"
        },
        "auth": {
            "failed": "These credentials do not match our records.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds."
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "messeges": [],
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, and dashes.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} is present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        },
        "my": {
            "on_the_page": "on the {url} page",
            "membership": "{-1} Lifetime|{1} Monthly|{3} Quarterly|{6} Half yearly|{12} Annually",
            "memberships_active": "Active",
            "memberships_at_risk": "At risk",
            "memberships_canceled": "Canceled",
            "memberships_finished": "Ended",
            "results": "{xx} results",
            "your_comment_length": "Your comment: {length} characters",
            "character_limit": "Max: {limit} characters",
            "no_time": "No time to use the platform",
            "no_value": "I didn't get much value out of it",
            "other": "Other reason",
            "expensive": "It's too expensive",
            "technical": "Technical problems",
            "alternative": "I found a better alternative",
            "definitely_return": "Definitely yes",
            "maybe_return": "Maybe",
            "probably_not_return": "Probably not",
            "never_return": "Definitely not",
            "waitx": "Wait {x} s to resend"
        }
    },
    "pl": {
        "The current token is hidden. Enter a new token to replace it.": "Token jest ukryty. Wprowadź nowy by go zastąpić.",
        "Create similar": "Utwórz podobny",
        "Purchase as business": "Chcę otrzymać fakturę",
        "Read now": "Przeczytaj",
        "Latest Article": "Najnowszy Artykuł",
        "Did you mean": "Czy chodziło o",
        "Have a coupon code?": "Masz kod rabatowy?",
        "Search for content": "Szukaj treści",
        "Find by title, description, author and tags": "Szukaj po tytule, opisie, autorze i tagach",
        "For you": "Dla Ciebie",
        "Editor's choice": "Twórca poleca",
        "Trending": "Popularne",
        "Online Course Platform": "Platforma Do Kursów Online",
        "Recommended": "Rekomendowany",
        "Not sure": "Trudno powiedzieć",
        "Choose a strong password for your account.": "Wybierz silne hasło do swojego konta.",
        "Enter your email and we will send you a reset link.": "Wprowadź swój adres e-mail, a my wyślemy Ci link do zresetowania hasła.",
        "Create your account to get started.": "Utwórz konto, aby rozpocząć.",
        "Welcome back! Please sign in to continue.": "Witamy ponownie! Zaloguj się, aby kontynuować.",
        "The plan automatically renews until canceled.": "Plan odnawia się automatycznie do momentu anulowania",
        "You can cancel at any time": "Możesz anulować w dowolnym momencie",
        "Paywall subpage": "Strona blokady dostępu",
        "Create paywall page": "Dodaj stronę blokady dostępu",
        "Tags as filters (on the left side)": "Tagi jako filtry (po lewej stronie)",
        "Other": "Inne",
        "Require verification": "Wymagaj weryfikacji",
        "Do not scan for login abuse": "Nie sprawdzaj pod kątem nadużyć związanych z logowaniem",
        "Force verification by mail": "Wymuś weryfikację mailową",
        "Not found. Please enter the information manually.": "Nie znaleziono podmiotu. Wpisz dane ręcznie.",
        "Paid": "Zapłacono",
        "Order parcel": "Zamów przesyłkę",
        "Recommended image sizes": "Rekomendowane rozmiary zdjęć",
        "Mobile background image": "Zdjęcie w tle dla telefonów",
        "Wrong password": "Nieprawidłowe hasło",
        "Upload avatar": "Prześlij awatar",
        "Verification": "Weryfikacja",
        "We have just sent a message to your email address": "Właśnie wysłaliśmy wiadomość na Twój adres e-mail",
        "We have just sent a message to the phone number": "Właśnie wysłaliśmy go na numer telefonu",
        "Failed to save phone number.": "Nie udało się zapisać numeru telefonu.",
        "Slide to register": "Przeciągnij, aby się zarejestrować",
        "Verify you're a human": "Zweryfikuj, że jesteś człowiekiem",
        "Slide handle": "Uchwyt suwaka",
        "Verified!": "Zweryfikowano!",
        "Please complete the slider verification.": "Proszę ukończyć weryfikację suwaka.",
        "No password field on checkout": "Nie wyświetlaj pola hasła na stronie zakupowej",
        "Random password will be send by email": "Losowe hasło zostanie wysłane na adres e-mail",
        "Please enter your phone number to verify your account": "Proszę podaj numer telefonu do weryfikacji",
        "Verification code": "Kod weryfikacyjny",
        "Please enter this code to complete your verification process.": "Proszę wprowadzić ten kod, aby zakończyć proces weryfikacji.",
        "If you did not request this code, you can safely ignore this email.": "Jeśli nie prosiłeś o ten kod, możesz bezpiecznie zignorować tę wiadomość e-mail.",
        "Your verification code is:": "Twój kod weryfikacyjny to:",
        "The verification code will be sent to your email address used for login": "Kod weryfikacyjny zostanie wysłany na Twój adres e-mail użyty do logowania",
        "Enter verification code": "Wprowadź kod weryfikacyjny",
        "Verify": "Zweryfikuj",
        "Send verification code": "Wyślij kod weryfikacyjny",
        "Resend code": "Wyślij kod ponownie",
        "Failed to send verification code.": "Nie udało się wysłać kodu weryfikacyjnego.",
        "Invalid or expired verification code.": "Nieprawidłowy lub wygasły kod weryfikacyjny.",
        "The verification code will be sent to your phone number": "Kod weryfikacyjny zostanie wysłany na Twój numer telefonu",
        "This number will be used to send one-time login codes": "Na ten numer będziemy wysyłać jednorazowe kody logowania",
        "Default": "Domyślny",
        "Editor": "Edytor",
        "Additional legal info on checkout page": "Dodatkowa informacja prawna na stronie zakupowej",
        "Above the payment button on checkout page": "Wyświetlona będzie nad przyciskiem zakupu",
        "Shipping notes": "Uwagi do zamówienia",
        "Shipment information": "Dane do wysyłki",
        "physical": "fizyczny",
        "Shipping": "Wysyłka",
        "Delivered": "Dostarczona",
        "Shipped": "Wysłana",
        "Ready for shipping": "Gotowa do wysyłki",
        "Street": "Ulica",
        "Parcel locker code": "Kod paczkomatu",
        "Transaction status": "Status transakcji",
        "Shipping status": "Status wysyłki",
        "Sell products that need shipping": "Sprzedawaj produkty wymagające wysyłki",
        "Physical product": "Produkt fizyczny",
        "If you have any questions or need assistance with your order, please contact our support team at": "Jeśli masz pytania lub potrzebujesz pomocy dotyczącej zamówienia, skontaktuj się z naszym zespołem wsparcia pod adresem",
        "Need help": "Zobacz zamówienie w panelu",
        "View order in app": "Zobacz zamówienie w panelu",
        "Ordering party": "Zamawiający",
        "New physical product order received": "Adres dostawy",
        "Shipping address": "Adres dostawy",
        "Order number": "Numer zamówienia",
        "Thank you for placing your order": "Dziękujemy za złożenie zamówienia",
        "Shipping cost": "Koszt dostawy",
        "No parcel lockers found": "Nie znaleziono paczkomatów",
        "Different shipping address": "Inny adres dostawy",
        "Courier": "Kurier",
        "Parcel locker": "Paczkomat",
        "Courier price": "Cena wysyłki - kurier",
        "Parcel locker price": "Cena wysyłki - paczkomat",
        "Border radius": "Promień zaokrąglenia",
        "Shadow": "Cień",
        "Seconds": "Sekundy",
        "Timer": "Czas",
        "Countdown mode": "Tryb odliczania",
        "Button during countdown": "Przycisk w trakcie odliczania",
        "Button after countdown": "Przycisk po zakończeniu odliczania",
        "Search popup": "Wyszukiwarka",
        "Which topic are you looking for?": "Jaki temat Cię interesuje?",
        "Recent searches": "Ostatnie wyszukiwania",
        "There are currently no videos shared through Skyier on your account": "Na Twoim koncie nie ma jeszcze żadnych filmów opublikowanych przez Skyier",
        "Countries by": "Kraje z podziałem na",
        "daily": "dzienne",
        "Views": "Wyświetlenia",
        "Watch time": "Czas oglądania",
        "Video stats": "Statystyki wideo",
        "return intent": "powrót",
        "Why are you canceling?": "Dlaczego rezygnujesz?",
        "Would you consider returning in the future?": "Czy rozważasz powrót w przyszłości?",
        "hidden": "ukryte",
        "Additional footer links": "Dodatkowe linki w stopce",
        "Add links tou your footer": "Dodaj linki do stopki",
        "header": "nagłówek",
        "Field identifier used in integration": "Identyfikator pola używany w integracjach",
        "Form": "Formularz",
        "Success header": "Nagłówek po wysyłce",
        "Success text": "Tekst po wysyłce",
        "Shows after the form is submitted": "Pokazuje się po wysłaniu formularza",
        "Hide this plan (only available through link)": "Ukryj ten plan (dostępny tylko przez link)",
        "Transaction": "Transakcja",
        "No certificates yet": "Nie posiadasz jeszcze żadnych certyfikatów",
        "Do not display prices": "Ukryj ceny produktów",
        "Optional marketing consent checkbox": "Opcjonalny checkbox zgody marketingowej",
        "I agree to receive the email newsletter, including information about new products, promotions, and services.": "Chcę otrzymywać e-mail newsletter - informacje o nowościach, promocjach, produktach lub usługach.",
        "No reviews yet": "Brak recenzji dla tego szkolenia",
        "Log in to be the first to share your thoughts": "Zaloguj się, aby zostawić pierwszą",
        "Make into review": "Dodaj do recenzji",
        "You have access to all online products available on the platform": "Masz dostęp do wszystkich materiałów szkoleniowych dostępnych na platformie",
        "Explore": "Przeglądaj",
        "Nothing to explore for now...": "Nic do przeglądania na ten moment...",
        "Last login at": "Ostatnie logowanie",
        "Resume playback": "Wznów odtwarzanie",
        "period": "okres",
        "Enter payment card details": "Wprowadź dane karty płatniczej",
        "Automatic review approval": "Automatyczne zatwierdzanie recenzji",
        "Reviews will be automatically approved and displayed inside the reviews element": "Recenzje będą automatycznie zatwierdzane i wyświetlane w elemencie recenzje",
        "No descriptive opinion": "Brak opinii opisowej",
        "Can you tell us what happened": "Napisz proszę, co się stało",
        "End survey results": "Ankieta zakończenia subskrypcji",
        "reason": "powód",
        "Subscription has been canceled": "Subskrypcja została anulowana",
        "We're sorry to see you leave. Please help us improve the platform by stating the reason why your subscription has ended": "Przykro nam, że odchodzisz. Pomóż nam poprawić platformę, podając powód zakończenia subskrypcji",
        "How many reviews to show": "Ilość pokazywanych recenzji",
        "recommended": "polecam",
        "neutral": "neutralny",
        "not recommended": "nie polecam",
        "disapprove": "odrzuć",
        "approve": "zatwierdź",
        "approved": "zatwierdzono",
        "free": "bezpłatnie",
        "Pay for results, not for limitations": "Rozliczaj się za efekty, a nie ograniczenia",
        "Show correct answers at the summary stage": "Pokaż poprawne odpowiedzi na widoku podsumowania",
        "Your answer": "Twoja odpowiedź",
        "Expected answer": "Oczekiwana odpowiedź",
        "Email pdf or zip files": "Wysyłaj na maila pliki pdf lub zip",
        "Rating": "Ocena",
        "Positive": "Pozytywna",
        "Neutral": "Neutralna",
        "Negative": "Negatywna",
        "Set if the product has a different vat rate": "Ustaw, jeśli produkt ma inną stawkę vat",
        "Default VAT rate": "Domyślna stawka VAT",
        "VAT rate": "Stawka VAT",
        "Price in pennies": "Cena w groszach",
        "Please try again": "Spróbuj ponownie",
        "No results this time": "Brak wyników dla danej frazy",
        "No results": "Brak wyników",
        "Before image": "Zdjęcie przed",
        "After image": "Zdjęcie po",
        "Before after": "Efekt przed i po",
        "drop-down": "lista rozwijana",
        "single-choice": "jednokrotny wybór",
        "multi-choice": "wielokrotny wybór",
        "No answers provided": "Nie zanotowaliśmy żadnych odpowiedzi",
        "Exam is already passed": "Egzamin został zaliczony",
        "visible next to comments": "widoczny obok komentarzy",
        "Instructor": "Instruktor",
        "Passing score": "Próg zdawalności",
        "Go to exam panel": "Przejdź do panelu egzaminacyjnego",
        "Exam failed": "Egzamin nie został zaliczony",
        "Try again later": "Spróbuj ponownie później",
        "You have successfully passed the exam": "Egzamin zaliczony",
        "Your certificate will be sent to your email": "Certyfikat zostanie wysłany na Twój adres e-mail",
        "You have answered {x} out of {sum} questions": "Odpowiedziałeś na {x} z {sum} pytań",
        "Are you ready to submit": "Czy wysłać odpowiedzi do sprawdzenia",
        "Attach exam": "Dołącz egzamin",
        "Choose an answer": "Wybierz odpowiedź",
        "Is correct": "Jest poprawna",
        "Exams": "Egzaminy",
        "Exam": "Egzamin",
        "exam": "egzamin",
        "Answers": "Odpowiedzi",
        "Additional classes": "Dodatkowe klasy",
        "Open in new tab": "Otwórz w nowej karcie",
        "Custom button": "Przycisk",
        "Quantity per student": "Ilość na studenta",
        "Promo code already used": "Kod rabatowy został wykorzystany",
        "Students can upgrade / downgrade to this plan": "Studenci mogą przejść na ten plan (upgrade / downgrade)",
        "Results": "Wyniki",
        "It will appear at the top of the survey": "Opis będzie widoczny na początku ankiety",
        "Remind me later": "Przypomnij mi później",
        "Initial value": "Wartość początkowa",
        "Required": "Wymagane",
        "Data type": "Rodzaj danych",
        "Field name": "Nazwa pola",
        "Field type": "Rodzaj pola",
        "Questions": "Pytania",
        "Number of questions": "Ilość pytań",
        "Surveys": "Ankiety",
        "Survey": "Ankieta",
        "Create survey": "Utwórz ankietę",
        "Updating your plan will adjust your subscription period accordingly": "Po aktualizacji planu data następnego pobrania ulegnie zmianie",
        "Captions": "Napisy",
        "Label": "Etykieta",
        "except products marked as": "poza produktami oznaczonymi jako",
        "Chosen": "Wybrane",
        "Transcription": "Transkrypcja",
        "Would you recommend this product to others?": "Czy poleciłbyś ten produkt innym?",
        "Why did you choose that answer?": "Dlaczego wybrałeś taką odpowiedź?",
        "Leave a review": "Zostaw recenzję",
        "Review": "Recenzja",
        "Reviews": "Recenzje",
        "Duration": "Czas trwania",
        "Lecture duration in minutes": "Czas trwania lekcji w minutach",
        "Lecture duration": "Czas trwania lekcji",
        "My products": "Moje produkty",
        "Recommended products": "Rekomendowane produkty",
        "All products": "Wszystkie produkty",
        "From": "Od",
        "from": "od",
        "to": "do",
        "Call To Action": "Wezwanie do działania",
        "Format message as plain text": "Sformatuj wiadomość jako zwykły tekst",
        "Sales recovery": "Odzyskiwanie sprzedaży",
        "Recovery message": "Wiadomość po nieudanym zakupie",
        "The integrated invoicing system will not issue accounting documents for individuals": "Zintegrowany system do fakturowania nie będzie wystawiał dokumentów księgowych dla osób fizycznych",
        "Only issue invoices to companies": " Wystawianie faktur tylko dla firm",
        "When you update your card details, the system will collect the payment": "Przy aktualizacji danych karty system pobierze płatność",
        "Thus extending access to the platform": "Przedłużając tym samym dostęp do platformy",
        "A community on your terms. No worrying about the 'algorithm'": "Społeczność na Twoich zasadach. Bez martwienia się o 'algorytm'",
        "Manage post permissions. Create topic categories dedicated to different groups": "Zarządzaj uprawnieniami do postów. Twórz kategorie tematyczne dedykowane różnym grupom",
        "Decide if members can add posts": "Decyduj czy członkowie mogą dodawać posty",
        "Engage members and respond to comments": "Angażuj członków i odpowiadaj na komentarze",
        "Members have access to the community, purchased products and your other offerings": "Członkowie mają dostęp do społeczności, zakupionych produktów oraz Twojej pozostałej oferty",
        "Increase conversions on cold traffic using limited time offer technique": "Zwiększaj konwersję na zimnym ruchu za pomocą ofert ograniczonych czasowo",
        "Pay what you want": "Zapłać, ile chcesz",
        "You can sell digital products and let your students decide the price": "Pozwól klientom zdecydować o cenie produktu online",
        "Increase average order value using order bumps": "Zwiększaj średnią wartość zamówienia oferując dodatkowe produkty",
        "More button": "Przycisk 'więcej'",
        "Sale limit": "Ograniczona ilość miejsc",
        "Assignment": "Zadanie",
        "assignment": "zadanie",
        "Notify me about leads": "Chcę otrzymywać powiadomienia o nowych leadach",
        "New lead received": "Nowy lead na platformie",
        "Event date": "Termin wydarzenia",
        "Wait for the event to start": "Zaczekaj aż wydarzenie się rozpocznie",
        "Choose your event from the list of purchased products": "Wybierz zakupione wydarzenie z listy produktów",
        "Log in to {platform} platform on the day of the event": "Zaloguj się do {platform} w dniu wydarzenia",
        "How it works": "Jak to działa",
        "Congratulations on purchasing an online event": "Gratuluję zakupu wydarzenia online",
        "Issue certificates for all": "Wyślij certyfikaty dla wszystkich",
        "Additional": "Dodatkowe",
        "Student renewed subscription": "Student odnowił subskrypcję",
        "Student has logged in": "Student zalogował się",
        "Auto renewal": "Automatyczne odnawianie",
        "Order bumps": "Dosprzedaż",
        "Show original price with strikethrough": "Pokaż oryginalną cenę z przekreśleniem",
        "No download": "Bez możliwości pobierania",
        "Display inside the lecture": "Wyświetlaj wewnątrz lekcji",
        "Checkbox text": "Treść zgody",
        "Headline": "Nagłówek",
        "Add to your order": "Dodaj do zamówienia",
        "{count} has renewed subscription": "{count} studentów przedłużyło dostęp do platformy",
        "Following students has renewed their membership": "W ciągu ostatnich 24h, dostęp do platformy został przedłużony dla",
        "Do not display logo / page name": "Nie wyświetlaj logo / nazwy strony",
        "Do not display course title": "Nie wyświetlaj tytułu",
        "Container size": "Rozmiar kontenera",
        "Limited": "Ograniczony",
        "Section unlocks on": "Sekcja będzie dostępna w dniu",
        "Full": "Na całą szerokość",
        "Transaction security is ensured by": "Bezpieczeństwo transakcji zapewnia",
        "By completing this purchase, I agree to": "Dokonując zakupu, akceptujesz",
        "Your plan": "Twój plan",
        "Upload thumbnail": "Wgraj miniaturkę",
        "Confirm and pay": "Kupuję i płacę",
        "Following products has been added to your account": "Następujące produkty zostały dodane do Twojego konta",
        "{Name} has disconnected card from platform": "{Name} odpiął kartę od platformy",
        "Card data is not valid": "Dane karty nie są poprawne",
        "We where unable to renew your subscription": "Nie udało się odnowić Twojej subskrypcji",
        "Subscription about to expire": "Subskrypcja wygaśnie jutro",
        "You can also log in at {domain} and go to Account → Subscription. We never ask for your card details in reply to an email.": "Możesz również zalogować się na stronie {domain} i przejść do sekcji Konto → Subskrypcja. Nigdy nie prosimy o podanie danych karty kredytowej w odpowiedzi na wiadomość e-mail.",
        "On {date}, we tried to renew your Premium subscription ({price}), but the payment didn't go through.": "W dniu {date} podjęliśmy próbę odnowienia Twojej subskrypcji Premium ({price}), ale płatność nie została zrealizowana.",
        "We have tried several times to collect the payment": "System napotkał problem kilkukrotnie w ciągu ostatnich kilku dni",
        "If you want to continue your subscription, please update your card": "Jeśli chcesz kontynuować subskrypcję, proszę uaktualnij dane karty",
        "Invoice email": "Email do wysłania faktury",
        "Transform to course": "Przekształć w kurs online",
        "Transform live event to course": "Za pomocą tej funkcji możesz przekształcić live w kurs online",
        "It will allow you to add additional content": "Co umożliwi Ci dodanie dodatkowych materiałów, w postaci plików czy grafik",
        "Users who had access to this live will still have it": "Użytkownicy, którzy mieli dostęp do tego live nadal będą go mieć",
        "Displaying publicly on your page": "Widoczne dla wszystkich na liście produktów",
        "Choose from public tags": "Wybierane z publicznych tagów",
        "Only for internal use": "Widoczne tylko dla Ciebie",
        "They can help you stay organised": "Pozwalają na lepszą organizację przy wielu produktach",
        "Private tags": "Tagi prywatne",
        "Set your price": "Zapłać ile chcesz",
        "User information": "Dane uczestnika",
        "Subtotal": "Kwota",
        "Check": "Sprawdź",
        "Total after trial": "Płatne po okresie testowym",
        "Total due today": "Płatne dzisiaj",
        "Renews at": "Odnowienie",
        "Lifetime access": "Dostęp na zawsze",
        "You save": "Oszczędzasz",
        "Summary": "Podsumowanie",
        "Suggested size": "Sugerowany rozmiar",
        "Custom template": "Własny szablon",
        "Read more": "Dowiedz się więcej",
        "Sorry for inconvenience": "Przepraszamy za utrudnienia",
        "Video upload is temporary unavailable": "Dodawanie wideo na platformę jest chwilowo niedostępne",
        "Allow members to add posts": "Pozwalaj studentom dodawać posty",
        "Watermark pdf with student's email": "Dodaj znak wodny w postaci adresu email studenta",
        "Allow to set price using url parameter": "Ustalanie ceny za pomocą linku",
        "Pay as much as you want": "Zapłać ile chcesz",
        "Attach file": "Dodaj plik",
        "Open file": "Otwórz plik",
        "Hide price": "Ukryj cenę",
        "color": "kolor",
        "Subscribe button": "Przycisk subskrypcji",
        "Buy button": "Przycisk zakupowy",
        "Show additional message": "Pokaż dodatkową wiadomość",
        "Organize online events or workshops": "Organizuj wydarzenia online lub warsztaty",
        "Live": "Wydarzenie",
        "Start date": "Data rozpoczęcia",
        "This event went live": "Wydarzenie rozpoczęło się",
        "This event starts in": "Wydarzenie rozpocznie się za",
        "Time restricted access": "Dostęp ograniczony czasowo",
        "Number of days": "Ilość dni",
        "Schedule a meeting": "Umów się na spotkanie",
        "Gather feedback and communicate with your students": "Zbieraj feedback uczestników pod lekcjami i rozwiązuj ich wszystkie wątpliwości",
        "Skyier integrates with populat payment systems, email marketing systems and invoicing systems": "Integrujemy się z systemami płatności, systemami do e-mail marketingu i systemami do fakturowania",
        "Your business online without all the fuss": "Buduj biznes online bez zbędnych zmartwień",
        "Set promotional prices for products, limited by duration and quantity": "Ustawiaj ceny promocyjne produktów, ograniczone czasem trwania oraz ilością",
        "Promotional prices": "Ceny promocyjne",
        "Build your community and share posts fitted for every group": "Buduj społeczność i udostępniaj posty dopasowane do każdej grupy",
        "Upsell your courses using bundles": "Spakuj podobne kursy w pakiet i zaoferuj jako wzbogacony produkt",
        "Bundles": "Pakiety",
        "Build and manage a community from one place": "Buduj i zarządzaj społecznością z jednego miejsca",
        "Sell effectively": "Sprzedawaj skutecznie",
        "Congratulations": "Gratulacje",
        "Issue": "Wystaw",
        "Refresh": "Odśwież",
        "Generate certificate": "Generuj certyfikat",
        "Certificate": "Certyfikat",
        "Certificates": "Certyfikaty",
        "Proudly Awarded To": "Przyznany dla",
        "For Successfully Completing": "Za ukończenie",
        "{page} has issued a certificate to you for completing {course}": "Certyfikat ukończenia {course} został wystawiony",
        "You can download it from attachments": "Możesz go pobrać z załącznika",
        "Email notifications": "Powiadomienia e-mail",
        "In app notifications": "Powiadomienia w panelu",
        "Topic": "Temat",
        "Topics": "Tematy",
        "Hey {Name}": "Cześć {Name}",
        "created a new post in": "dodał nowy post w temacie",
        "You are receiving this email because you signed up for notifications from {topic}": "Otrzymujesz tego maila, ponieważ masz włączone notyfikacje w temacie {topic}",
        "You can": "Możesz",
        "change your notification settings": "zmienić ustawienia notyfikacji",
        "if you no longer want to receive these emails": "jeśli nie chcesz otrzymywać tych wiadomości",
        "General": "Ogólny",
        "You can only use this feature once per minute": "Ta funkcjonalność może być używana raz na minutę",
        "Validation errors": "Potencjalne błędy",
        "No errors detected": "Brak komunikatu błędu",
        "Access expires in {number} days": "Dostęp wygasa za {number} dni",
        "shared a new post": "- nowy post na grupie",
        "View post and take part in the discussion": "Zobacz i weź udział w dyskusji",
        "View post": "Przejdź do posta",
        "We are waiting for you": "Czekamy na Ciebie",
        "Start": "Rozpocznij",
        "Blue": "Niebieski",
        "Video uploaded": "Wideo zostało załadowane",
        "Delete all elements": "Usuń wszystkie elementy",
        "Thank you page": "Strona z podziękowaniem po zakupie",
        "Subscriptions": "Subskrybenci",
        "Choose who will have access to this post": "Wybierz kto będzie miał dostęp do tego posta",
        "Students with active subscription": "Studenci z aktywną subskrypcją",
        "Students with access to chosen products": "Studenci z dostępem do wybranych produktów",
        "Visibility": "Widoczność",
        "public": "publiczny",
        "Public": "Publiczny",
        "Restricted": "Ograniczony",
        "restricted": "ograniczony",
        "Next attempt": "Następna próba pobrania",
        "Status change can take up to 72h": "Zmiana statusu może potrwać do 72h",
        "Payment method": "Metoda pobrania",
        "past_due (payment failed)": "problem z pobraniem płatności",
        "Update payment method": "Aktualizuj metodę płatności",
        "Create custom thank you page": "Dodaj stronę z podziękowaniem po zakupie",
        "Add page": "Dodaj stronę",
        "Pages": "Strony",
        "Students will get access to community tab": "Studenci będą mieli dostęp do społeczności, gdzie będą wyświetlane posty",
        "Display as slider": "Wyświetl jako slider",
        "enabled": "aktywny",
        "disabled": "nieaktywny",
        "Your post here": "Treść posta tutaj",
        "Community": "Społeczność",
        "Updated at": "Ostatnia aktualizacja",
        "Comment threads": "Dyskusje",
        "Unseen comments": "Nieprzeczytane komentarze",
        "Hide": "Ukryj",
        "Show": "Pokaż",
        "Reply": "Odpowiedz",
        "replies": "odpowiedzi",
        "Congratulations on your perfect helpdesk": "Gratuluję perfekcyjnego helpdesku",
        "Cool, you could charge extra for such support - I'll also be happy to pay a commission. This way we are in the same boat": "Luzik, za taki support mogłabyś charge'ować extra - także chętnie zapłacę prowizję. Mój sukces to Wasz sukces :) tego się trzymajmy",
        "Your payment did not go through": "Płatność nie powiodła się",
        "Most popular reasons: there is a typo (mailbox does not exist), mailbox is full, mailbox has aggresive spam filters turned on": "Najczęstsze powody: literówka w adresie e-mail (adres email nie istnieje), skrzynka jest pełna, skrzynka ma agresywny filtr antyspamowy",
        "You can change e-mail address by logging in and editing student details": "Możesz zmienić adres e-mail po zalogowaniu i edycji danych studenta",
        "did not receive send e-mails": "nie otrzymuje wysłanych wiadomości e-mail",
        "marked email message as spam": "oznaczył wiadomość e-mail jako spam",
        "Display optional phone field during checkout": "Na stronie zakupowej użytkownik będzie miał możliwość podania numeru telefonu",
        "Optional phone field": "Opcjonalny numer telefonu",
        "Phone": "Numer telefonu",
        "This lecture is not available in chosen variant": "Ta lekcja nie jest dostępna w wybranym wariancie",
        "Section will be available for students who bought": "Sekcja będzie dostępna dla studentów, którzy wykupili",
        "Account already exists": "Konto już istnieje.",
        "Choose": "Wybierz",
        "optional": "opcjonalnie",
        "Price variants": "Warianty cenowe",
        "Confirmation of online event purchase": "Potwierdzenie zakupu wydarzenia online",
        "variants": "warianty",
        "Variants": "Warianty",
        "Variant": "Wariant",
        "Your subscription will expire on {date}": "Subskrypcja zakończy się w dniu {date}",
        "Sell products with diffrenet prices. You can setup 3 different prices with different contents": "Sprzedaż kursu w różnych wariantach cenowych. Można dodać 3 różne ceny i różne zawartości kursu dla poszczególnych cen",
        "Reduce number of gathered information on the checkout page. Only First Name, Email and Password will be required": "Na stronie zakupowej użytkownik będzie musiał podać imię, email i hasło. Formularz do zbierania dodatkowych danych osobowych nie będzie dostępny",
        "On the checkout page": "Na stronie zakupowej",
        "Display no return policy info above the BUY NOW button": "Informacja pokaże się na stronie dokonywania zakupu (checkoucie), nad przyciskiem KUP TERAZ i będzie miała formę: Klikając poniższy przycisk oświadczam, że chcę natychmiastowego rozpoczęcia świadczenia Usługi i rozumiem, że nie będę mieć możliwości odstąpienia od umowy przed upływem 14 dni",
        "Add links tou your top navigation bar": "Dodane linki pokażą się w górnej nawigacji",
        "You can create your sales pages anywhere (example: WordPress). Your students will use the platform to log in and watch your courses. Remember to add links to checkout page inside your sales pages": "Możesz stworzyć strony sprzedażowe na WordPressie lub innym page builderze. Wówczas studenci będą używali platformy do logowania się i oglądania materiałów szkoleniowych. Pamiętaj, aby Twoje strony sprzedażowe zawierały link do naszych stron dokonywania zakupu (checkoutu)",
        "Promo code field will be available on the checkout page, above the BUY NOW button": "Pole do wpisania kodu rabatowego pojawi się nad przyciskiem KUP TERAZ",
        "Invoices will be generated once you click on the ATTEMPT button on the Sales page": "Faktury będą wystawiane w momencie, kiedy klikniesz \"attempt\" na stronie SPRZEDAŻ, przy danej transakcji zakupowej",
        "Welcome message will be available for students that have active subscription": "Wiadomość będzie widoczna dla studentów, którzy wykupili subskrypcję. Pojawi się w ich platformie szkoleniowej",
        "Welcome message will be available for students that paid for a course or bundle": "Wiadomość będzie widoczna dla studentów, którzy kupili kurs, pakiet. Pojawi się w ich platformie szkoleniowej",
        "Your articles page will be available in your top navigation under desired name": "Strona pojawi się automatycznie w górnej nawigacji i będzie zawierała artykuły, które dodasz w zakładce ARTYKUŁY",
        "This student already has access to this product": "Student ma już nadany dostęp do tego produktu",
        "Product is not visible in product lists": "Produkt nie będzie widoczny na liście produktów",
        "Anyone who previously purchased the produkct will continue to have access": "Studenci, którzy kupili produkt, dalej będą mieli do niego dostęp",
        "Enrollment disabled": "Produkt wyłączony ze sprzedaży",
        "You can display promo code field on your checkout page by going to": "Aby wyświetlać pole do wpisania kodu rabatowego na stronie zakupowej, wejdź w",
        "and toggle": "i aktywuj opcję",
        "Choose your plan and start selling": "Wybierz plan i rozpocznij sprzedaż",
        "subscription access": "dostęp subskrypcyjny",
        "has registered": "zarejestrował/a się",
        "logged in": "zalogował/a się",
        "bought": "kupił/a",
        "Try splitting your comment": "Spróbuj podzielić komentarz",
        "instructor_action": "manualny dostęp",
        "No return policy info": "Informacja na temat braku możliwości dokonania zwrotu",
        "By clicking the button below to proceed you agree that you will be provided with immediate access to digital content as soon as you complete your purchase, without waiting the 14-day withdrawal period. Therefore, you expressly waive your right to withdraw from this purchase.": "Klikając poniższy przycisk oświadczam, że chcę natychmiastowego rozpoczęcia świadczenia Usługi i rozumiem, że nie będę mieć możliwości odstąpienia od umowy przed upływem 14 dni.",
        "Toggle audio autoplay": "Automatyczne odtwarzanie kolejnych materiałów audio",
        "Toggle video autoplay": "Automatyczne odtwarzanie kolejnych materiałów wideo",
        "Continue to next lecture": "Przejdź dalej",
        "Complete and go to next lecture": "Oznacz materiał jako ukończony i przejdź dalej",
        "Mark lecture as completed": "Oznacz materiał jako ukończony",
        "Toggle lecture list": "Pokaż / ukryj listę lekcji",
        "People like you use Skyier to build websites, sell courses and digital products, host communities and webinars": "Osoby, takie jak Ty używają Skyier do budowania stron internetowych, sprzedaży kursów i produktów cyfrowych oraz prowadzenia społeczności i webinarów",
        "Skyier has everything you need to run a profitable online business": "Skyier posiada wszystko, czego potrzebujesz do prowadzenia zyskownego biznesu online",
        "Add an online course": "Dodaj kurs online",
        "Upload materials: video, audio, pdf, doc, excel, zip, photos and start sharing them with your participants": "Wgraj materiały: wideo, audio, pdf, doc, excel, zip, zdjęcia i zacznij je udostępniać swoim uczestnikom",
        "Create a sales page": "Stwórz stronę sprzedażową",
        "Use ready-made components and build a website to sell your products": "Skorzystaj z gotowych komponentów i zbuduj stronę do sprzedaży swoich produktów",
        "Integrate and sell": "Zintegruj i sprzedawaj",
        "Plug in the e-mail marketing, invoicing and payment system and start selling": "Podepnij system do e-mail marketingu, fakturowania oraz płatności i ruszaj ze sprzedażą",
        "Everything you need to sell your courses successfully": "Wszystko czego potrzebujesz do skutecznej sprzedaży kursów",
        "Consulting and other digital products": "Konsultacji oraz innych produktów cyfrowych",
        "Various sales models": "Różne modele sprzedaży",
        "expires with subscription": "wygasa wraz z subskrypcją",
        "Sell ​​products in the single and subscription payment model or by combining both models at the same time": "Sprzedawaj produkty w modelu pojedynczych lub subskrypcyjnych płatności oraz łącząc ze sobą oba modele jednocześnie",
        "Sale of multiple licenses": "Sprzedaż wielu licencji",
        "Sell training for large companies and corporations that wish to purchase access to materials for more employees": "Sprzedawaj szkolenia dla dużych firm i korporacji, które chcą zakupić dostęp do materiałów dla większej ilości pracowników",
        "Share your knowledge on the platform also by means of valuable articles": "Dziel się na platformie swoją wiedzą również za pomocą wartościowych artykułów",
        "Affiliate program": "Program afiliacyjny",
        "Collaborate with others and start your affiliate program": "Współpracuj z innymi i uruchom swój program partnerski",
        "Delaying availability": "Opóźnianie dostępności",
        "Share content at selected intervals": "Udostępniaj materiały w wybranych odstępach czasowych",
        "Discount Codes": "Kody rabatowe",
        "Set discount codes limited by time and quantity": "Ustawiaj kody rabatowe limitowane czasem oraz ilością",
        "Page editor": "Edytor stron",
        "A proprietary page editor that allows for quick and easy-to-use editing of sales pages": "Autorski edytor stron pozwalający na szybką i łatwą w obsłudze edycje stron sprzedażowych",
        "Content hosting": "Hosting materiałów",
        "Video, picture and file storage included": "Przechowywanie materiałów wideo, obrazków i plików w cenie",
        "We play to one goal. We will never leave you alone with the problem": "Gramy do jednej bramki. Nigdy nie zostawimy Cię samego z problemem",
        "Thank you for your trust": "Dziękujemy za zaufanie",
        "You are fantastic": "Jesteście fantastyczni",
        "Okay, I'm waiting 🙂 Can I ask you something? Why don't you have a review card on your fanpage? As for me, you have a great product and exemplary customer service, so a few opinions from satisfied customers could improve the ranges, I would write something good myself, because contact with you is at a very high level 🙂": "Dobra, to czekam 🙂 Mogę o coś zapytać? Czemu nie macie na fanpage'u karty recenzje? Macie jak dla mnie świetny produkt i wzorową obsługę klienta, więc kilka opinii od zadowolonych klientów mogło by poprawić zasięgi, sam bym coś napisał dobrego, bo kontakt z wami jest na bardzo wysokim poziomie 🙂",
        "The platform surprised me with the level of professionalism - it looks like it was prepared by a corporation with experience. (...) First of all, it is functional - it works and works well. You have also thought through many details. It's obvious that it is impossible to create a finished product in this industry - constant updates are the required standard today ... the more fun that you are open to suggestions.": "Platforma zaskoczyła mnie poziomem profesjonalizmu - robi wrażenie przygotowanej przez korporację z doświadczeniem. (...) Przede wszystkim jest funkcjonalna - działa i działa dobrze. Przemyśleliście również wiele detali. To oczywiste, że nie da się stworzyć w tej branży produktu skończonego - stałe update'y to dziś wymagany standard... tym bardziej fajnie, że jesteście otwarci na sugestie.",
        "Skyier is a complete and technologically advanced platform. The servers run without downtime. New technological innovations are constantly being implemented. Particular recognition is due to the efficiently operating support. There are various problems associated with running a training platform, so immediate support is extremely valuable. It is also important that the Skyier team is open to new proposals as to the shape of the platform and performs them extremely efficiently and quickly.": "Skyier to platforma kompletna i technologicznie trzymająca bardzo wysoki poziom. Serwery działają bez przestojów. Wdrażane są wciąż nowe nowinki technologiczne. Szczególne uznanie należy się za sprawnie działający support. Prowadzenie platformy szkoleniowej wiąże się z różnymi problemami, dlatego natychmiastowe wsparcie jest niezwykle cenne. Ważne jest również to, że ekipa Skyiera otwarta jest na nowe propozycje co do kształtu platformy i wykonuje je niezwykle sprawnie i szybko.",
        "Thank you, you are probably the most helpful support in the world 🙂 This is how I was recommended you too 🙂 But you exceed all expectations 🙂": "Dziękuję, jesteście chyba najbardziej pomocny supportem na świecie 🙂 Tak mi też was polecono 🙂 Ale przekraczacie wszelkie oczekiwania 🙂",
        "And thanks I will remember. Indeed, your support is above average 🙂": "A dzięki będę pamiętał. Rzeczywiście Wasz support jest nadprzeciętny 🙂",
        "Thanks for the quick answers at all, maybe the second time in my life as an entrepreneur that I feel so taken care of. Slogans from the site are not slogans!": "Dzięki w ogóle za szybkie odpowiedzi, może drugi raz w życiu przedsiębiorcy czuję się taki zaopiekowany. Slogany ze strony nie są sloganami!",
        "Skyier is a solution for anyone who appreciates time, simplicity and efficiency. The platform is intuitive and easy to use. I can count on help and support in every situation. Thanks to working with Skyier - I can focus on my activities without worrying about the issues related to the functioning of the platform. The platform is also systematically expanded, which makes it even easier to use. When I started working with the online course, I had absolutely no knowledge or experience with the necessary settings and functions, I felt lost and discouraged. Natalia from Skyier led me step by step, pointed out the necessary elements, helped in launching the necessary functions, and also provided the necessary tips, thanks to which I regained control over the situation and I could calmly focus on building the content of my e-learning platform. Thank you!": "Skyier to rozwiązanie dla każdego kto ceni sobie czas, prostotę i skuteczność. Platforma jest intuicyjna i prosta w obsłudze. W każdej sytuacji mogę liczyć na pomoc i wsparcie. Dzięki pracy ze Skyier'em – mogę skupić się na swoich działaniach nie martwiąc się o kwestie związane z funkcjonowaniem platformy. Platforma jest też systematycznie rozbudowywana, co czyni ją jeszcze łatwiejszą w obsłudze. Kiedy zaczynałam pracę z kursem online nie miałam zupełnie wiedzy ani doświadczenia w kwestii niezbędnych ustawień, funkcji, czułam się zagubiona i zniechęcona. Natalia ze Skyiera poprowadziła mnie krok po kroku, wskazała niezbędne elementy, pomogła w uruchomieniu niezbędnych funkcji, dodatkowo też dostarczyła niezbędnych wskazówek, dzięki czemu odzyskałam kontrolę nad sytuacją i ze spokojem mogłam skupić się budowaniu treści mojej platformy e-learningowej. Dziękuje!",
        "And Skyier, in my opinion, is shifting the market in terms of price and platform transparency. Really very good job with this lesson builder and platform in general.": "A Skyier, to moim zdaniem rozmiata rynek pod względem ceny i przejrzystości platformy. Naprawdę bardzo dobra robota z tym builderem lekcji i ogólnie platformą.",
        "We integrate well with others": "Dobrze integrujemy się z innymi",
        "If you need something more - please let us know": "Jeśli potrzebujesz czegoś więcej - daj nam znać",
        "Simple billing model that brings our goals closer": "Prosty model rozliczenia, który sprawia, że gramy do jednej bramki",
        "Thank you for your interest in our product": "Dziękujemy, że zainteresowałeś się naszym produktem",
        "A few words from us": "Kilka słów od nas",
        "VAT ID": "NIP",
        "{Name} has registered to your platform": "Nowa rejestracja na Twojej platformie: {Name}",
        "Back to the platform": "Wróć do platformy",
        "Copy all elements": "Skopiuj wszystkie elementy",
        "Promo code here": "Tutaj kod promocyjny",
        "Total due": "Do zapłaty",
        "Visit first lecture inside this course": "Przejdź do pierwszej lekcji w tym kursie",
        "No lecture found": "Nie znaleziono takiej lekcji",
        "Add your first page element": "Dodaj pierwszy element do strony",
        "Possible answers": "Możliwe odpowiedzi",
        "Go to your product list": "Przejdź do listy dostępnych produktów",
        "Content": "Treść",
        "Design": "Wygląd",
        "Preview might not be accurate": "Podgląd tego elementu może być inny niż faktyczny element",
        "Shift click to move element to the top": "Kliknięcie + Shift przesunie element na początek",
        "Shift click to move element to the bottom": "Kliknięcie + Shift przesunie element na koniec",
        "Section": "Sekcja",
        "Simplified preview": "Podgląd uproszczony",
        "Editor preview mode": "Podgląd w edytorze",
        "Subscription access granted": "Dostęp do subskrypcji został przyznany",
        "Sign up to see this content for free": "Zaloguj się, aby zobaczyć ten materiał za darmo",
        "Number of trial days": "Ilość dni trialu",
        "Additional info": "Informacje dodatkowe",
        "Custom html": "Własny html",
        "First payment": "Pierwsza płatność",
        "Then": "Następnie",
        "for": "za",
        "Chosen product list": "Lista wybranych produktów",
        "Membership plans": "Plany subskrypcyjne",
        "Previous error": "Poprzedni komunikat błędu",
        "Attempt to generate an invoice": "Podejmij próbę wygenerowania faktury",
        "multiple licences": "wiele licencji",
        "You can only make one export per minute": "Eksport danych jest możliwy raz na minutę",
        "Export with enabled filters": "Eksportuj dane wraz z aktywnymi filtrami",
        "Affilate codes": "Afiliacja",
        "Subscription expired": "Subskrypcja wygasła",
        "No subscription": "Brak subskrypcji",
        "One time purchases": "Zakup produktów z pojedynczą płatnością",
        "Remove membership instantly": "Usuń subskrypcję natychmiast",
        "Knowledge base": "Baza wiedzy",
        "Pay now": "Zapłać teraz",
        "Code has to be unique": "Kod musi być unikalny",
        "Coupon code expired": "Kod stracił ważność",
        "Quantity": "Ilość",
        "Expiry date": "Data ważności",
        "It can take some time": "Może to chwilę zająć",
        "Working on it": "Pracujemy nad tym",
        "Black": "Czarny",
        "Grey": "Szary",
        "Teal": "Morski",
        "Green": "Zielony",
        "Pink": "Różowy",
        "Dark": "Ciemny",
        "Light": "Jasny",
        "Cyan": "Błękitny",
        "Purple": "Fioletowy",
        "Yellow": "Żółty",
        "Orange": "Pomarańczowy",
        "Red": "Czerwony",
        "outline": "ramka",
        "Primary": "Główny",
        "Secondary": "Poboczny",
        "Info": "Informacja",
        "Danger": "Niebezpieczeństwo",
        "Style": "Styl",
        "Lightbox grid": "Siatka z efektem lightbox",
        "Standard": "Standardowy",
        "yes": "tak",
        "no": "nie",
        "Display content as card": "Wyświetlaj treść w karcie",
        "Student will no longer have access to this course": "Student straci dostęp do tego kursu",
        "Text position": "Pozycja tekstu",
        "left": "lewo",
        "top": "góra",
        "bottom": "dół",
        "center": "środek",
        "right": "prawo",
        "Background color": "Kolor tła",
        "Header color": "Kolor nagłówka",
        "Text color": "Kolor tekstu",
        "Background image": "Zdjęcie w tle",
        "Position": "Pozycja",
        "Repeat": "Powtarzanie",
        "repeat": "powtarzaj",
        "repeat-x": "tylko na osi x",
        "repeat-y": "tylko na osi y",
        "no-repeat": "nie powtarzaj",
        "Column size": "Rozmiar kolumny",
        "Padding top": "Odstęp górny",
        "Padding bottom": "Odstęp dolny",
        "Load more results": "Więcej wyników",
        "We will miss you!": "Będziemy za Tobą tęsknić!",
        "Clear": "Wyczyść",
        "Close": "Zamknij",
        "{Name} has joined your subscription platform": "{Name} dołączył/a do subskrypcji",
        "A new member has joined": "Nowy uczestnik dołączył do subskrypcji",
        "Oops... Nothing here yet": "Ups... chwilowo tutaj jest pusto",
        "Monthly": "Miesięcznie",
        "Quarterly": "Kwartalnie",
        "Half yearly": "Półrocznie",
        "Annually": "Rocznie",
        "Lifetime": "Lifetime",
        "Lecture comments": "Komentarze do lekcji",
        "It will be not be possible to recover the content": "Odzyskanie treści nie będzie możliwe",
        "Confirm": "Potwierdź",
        "Engagement": "Zaangażowanie",
        "Progress": "Postęp",
        "No published lectures in this course yet": "Lekcje w tym kursie nie zostały jeszcze opublikowane",
        "Please contact me if you have any questions": "Proszę, napisz do mnie w razie pytań",
        "Validation error": "Sprawdź czy wszystkie pola zostały wypełnione poprawnie",
        "percentage based": "procentowy",
        "amount based": "kwotowy",
        "This video is now transcoding. Please reload the page in few minutes to check if it has uploaded correctly.": "Wideo jest w trakcie przetwarzania przez serwer. Odśwież stronę za kilka minut.",
        "Set selected frame as thumbnail": "Ustaw wybraną klatkę jako miniaturkę",
        "Loading...": "W toku...",
        "Back to students list": "Powrót do listy studentów",
        "bundle": "pakiet",
        "consultation": "konsultacja",
        "course": "kurs",
        "Compress image": "Kompresuj zdjęcie",
        "Save and preview": "Zapisz i sprawdź",
        "Congratulations!": "Gratulacje!",
        "All lectures marked as completed": "Wszystkie lekcje zostały oznaczone jako zakończone",
        "Go back to dashboard": "Wróć do strony z kursami",
        "Complete": "Zakończ",
        "Complete and continue": "Zakończ i przejdź dalej",
        "Please check your inbox": "Proszę sprawdź swoją skrzynkę odbiorczą",
        "An email is on the way": "Wiadomość e-mail jest już w drodze",
        "Create a series of lessons with video, images and other types of content": "Stwórz lekcje z elementami wideo, zdjęciami i innymi materiałami",
        "Sell online consultation (one on one)": "Sprzedawaj konsultacje online (jeden na jeden)",
        "Sell a collection of online courses": "Sprzedawaj kolekcję składającą się z kilku kursów online",
        "Product title": "Nazwa produktu",
        "Online consultation": "Konsultacja online",
        "Nevermind": "Anuluj",
        "Online course": "Kurs online",
        "Choose type": "Wybierz rodzaj",
        "You can use Markdown here": "Możesz użyć składni Markdown",
        "Call to action": "Wezwanie do działania",
        "Message after successful purchase": "Wiadomość po zakupie",
        "Products": "Produkty",
        "Add product": "Dodaj produkt",
        "Skyier will automatically send InitiateCheckout and Purchase events": "Skyier automatycznie wysyła eventy InitiateCheckout oraz Purchase",
        "Sold separately": "Produkt sprzedawany poza subskrypcją",
        "Subscribers won't be able to access this course": "Studenci, którzy są na planie subskrypcyjnym nie będą mieli dostępu do tego produktu",
        "Only name, email and password will be required": "Tylko imię, email i hasło będą wymagane",
        "Simplified checkout page": "Uproszczona strona zakupowa",
        "Checkout page": "Strona dokonywania zakupu",
        "Before choosing your plan": "Zanim wybierzesz plan",
        "A new student has registered": "Nowy student się zarejestrował",
        "you can change currency here": "ustaw walutę rozliczenia",
        "Our system is going to send an email with login credentials few minutes after clicking the add button": "Po dodaniu, w ciągu kilku minut, na wskazany adres zostanie wysłany e-mail z danymi do logowania",
        "Reload the page to see the student on the students list": "Odśwież stronę, aby zobaczyć studenta na liście",
        "The student has agreed to the terms and privacy policy of my platform": "Oświadczam, że osoba ta wyraziła zgodę na dodanie do platformy, zapoznała się z regulaminem i polityką prywatności",
        "Exempt from VAT reason": "Powód zwolnienia z VAT",
        "Regular price": "Cena regularna",
        "The lowest price in the last 30 days": "Najniższa cena z 30 dni",
        "Welcome! Your account has been created": "Twoje konto zostało utworzone",
        "Please remember to change your password after you log in": "Proszę pamiętaj o zmianie hasła po zalogowaniu",
        "Temporary password": "Tymczasowe hasło",
        "Welcome, {Name}": "Dzień dobry, {Name}",
        "You've been added to {domain} as a student": "Przyznano Ci dostęp do {domain}",
        "Add student": "Dodaj studenta",
        "Import students": "Importuj studentów",
        "Tip: email addresses separated by new line": "Wskazówka: każdy adres e-mail w nowej linii",
        "Max: 50 emails": "Maks: 50 adresów e-mail",
        "Email list": "Lista adresów e-mail",
        "Manage access for multiple students": "Zarządzaj dostępami dla wielu studentów",
        "Make this audio content downloadable": "Plik audio jest możliwy do pobrania",
        "Checkbox text here": "Tutaj treść zgody (checkbox)",
        "Delete student": "Usuń studenta",
        "Upon deletion, all information associated with this student will be unrecoverable.": "Po usunięciu, wszystkie dane związane ze studentem będą NIEMOŻLIWE do odzyskania.",
        "Documents": "Dokumenty",
        "All checkboxes are required": "Wszystkie powyższe pola są wymagane",
        "(instead of default one)": "(zamiast standardowych)",
        "Required checkboxes": "Wymagane checkboxy",
        "If you want to include a link, use this code:": "Jeśli chcesz wstawić link, użyj tego kodu:",
        "All checkboxes will be required": "Wszystkie pola będą wymagane",
        "Recommended size:": "Sugerowany rozmiar:",
        "Get free access": "Odbierz dostęp",
        "Thank-you page": "Strona z podziękowaniem po zakupie",
        "Main page": "Strona główna",
        "Select a course": "Wybierz kurs",
        "Copy to": "Kopiuj do",
        "Watch for free": "Oglądaj za darmo",
        "Use images with the same size": "Używaj obrazków o jednakowych rozmiarach",
        "TIP": "Wskazówka",
        "gallery": "galeria",
        "Gallery": "Galeria",
        "Turn off automatic renewal": "Wyłącz automatyczne odnawianie",
        "Connect new payment method": "Podłącz nową metodę płatności",
        "If you have any questions, please let us know. We will be happy to help.": "Jeśli masz jakieś pytania, proszę daj nam znać. Bardzo chętnie odpowiemy.",
        "WE COULDN'T PROCESS YOUR PAYMENT": "OSTATNIA PŁATNOŚĆ NIE POWIODŁA SIĘ",
        "Unfortunately, we couldn't collect payment on your subscription. Please take a moment to review your billing information-if it looks correct, please reply to this email to let us know. Otherwise, please update your information.": "Niestety nie byliśmy w stanie pobrać ostatniej opłaty za konto Skyier. Proszę sprawdź swoją kartę i jeśli wszystko jest prawidłowo odpowiedz na tę wiadomość. Jeśli nie, proszę zaktualizuj swoją kartę płatniczą.",
        "New payment method connected": "Dodano nową metodę płatności",
        "Add payment method": "Dodaj metodę płatności",
        "Your subscription is going to be canceled at": "Twoja subskrypcja zakończy się",
        "canceles at": "wygasa",
        "net": "netto",
        "Thank you!": "Dziękujemy!",
        "We are honoured to have you here. You are awesome!": "Bardzo się cieszymy, że jesteś z nami!",
        "Student started subscription": "Student rozpoczął subskrypcję",
        "Student ended subscription": "Student zakończył subskrypcję",
        "Student has subscribed to presale / newsletter": "Student zapisał się na przedsprzedaż / newsletter",
        "This feature is not ready yet": "Ta funkcjonalność nie jest jeszcze gotowa",
        "Please contact us": "Proszę skontaktuj się z nami",
        "Current plan": "Bieżący plan",
        "Change payment method": "Zmień metodę płatności",
        "Change plan": "Zmień plan",
        "Choose your new plan": "Wybierz swój nowy plan",
        "Selected": "Wybrano",
        "Select": "Wybierz",
        "Per month flat fee": "Stała opłata miesięczna",
        "Sales provision": "Prowizja od sprzedaży",
        "First and last name on card": "Imię i nazwisko na karcie płatniczej",
        "In progress...": "Przetwarzanie...",
        "You will be charged at the end of billing period": "Opłata zostanie pobrana na koniec okresu rozliczeniowego",
        "Your subscription will start now": "Subsktypcja rozpocznie się natychmiast",
        "Enter your card details": "Wprowadź dane karty płatniczej",
        "Online payments -> My shops -> Choose your shop -> POS -> Choose your POS -> Configuration keys": "Płatności elektroniczne -> Moje sklepy -> Wybierz nazwę sklepu -> Punkty płatności -> Wybierz nazwę punktu płatności -> Klucze konfiguracji",
        "Set password": "Ustaw hasło",
        "Set new password": "Ustaw nowe hasło",
        "Force password change on first login": "Wymuś zmianę hasła przy pierwszym logowaniu",
        "Current password": "Dotychczasowe hasło",
        "New password": "Nowe hasło",
        "Menu -> Integrations -> API": "Menu -> Integracje -> API",
        "List Token": "Token listy",
        "Pos ID": "Id punktu płatności",
        "Shop ID": "ID Sprzedawcy",
        "Merchant ID": "Identyfikator",
        "CRC Key": "Klucz do CRC",
        "Environment": "Środowisko",
        "Production": "Produkcyjne",
        "Sandbox": "Testowe - Sandbox",
        "Settings -> Notifications -> Security": "Ustawienia -> Powiadomienia -> Bezpieczeństwo",
        "Quarter": "Kwartał",
        "Two weeks": "Dwa tygodnie",
        "membership": "subskrypcja",
        "Skyier monthly access and transaction provision": "Dostęp do platformy Skyier oraz prowizja od sprzedaży",
        "Skyier monthly access": "Dostęp do platformy Skyier",
        "Email contains further instructions": "Znajdują się w niej dalsze instrukcje",
        "Go to main page": "Wróć do strony głównej",
        "Go to my courses": "Przejdź do platformy",
        "Check comments": "Sprawdź komentarze",
        "Check reviews": "Sprawdź recenzje",
        "Notify me about new reviews": "Chcę otrzymywać powiadomienia o nowych recenzjach",
        "Notify me about new comments": "Chcę otrzymywać powiadomienia o nowych komentarzach",
        "Notify me about new students": "Chcę otrzymywać powiadomienia o nowych rejestracjach",
        "A new comment appeared": "Pojawił się nowy komentarz",
        "A new review appeared": "Pojawiła się nowa recenzja",
        "A new reply appeared": "Pojawiła się nowa odpowiedź",
        "New review from": "Nowa recenzja od",
        "New reply from": "Nowa odpowiedź od",
        "New comment from": "Nowy komentarz od",
        "A new community post appeared": "Pojawił się nowy post w społeczności",
        "New community post from": "Nowy post od",
        "Find a course": "Szukaj kursu",
        "Notifications": "Powiadomienia",
        "Consultation": "Konsultacje",
        "Notify me about completed transactions": "Chcę otrzymywać powiadomienia o ukończonych transakcjach",
        "{Name} has bought one of your products": "Twój produkt został kupiony przez: {Name}",
        "{Name} paid for consultation": "Użytkownik wykupił produkt: {Name}",
        "New transaction on your platform": "Nowa transakcja na Twojej platformie",
        "Insufficient funds": "Brak środków",
        "Card usage limit exceeded": "Limit karty",
        "Not activated or limit exceeded": "Karta nieaktywna",
        "Insufficient funds or card usage exceeded": "Brak środków na karcie lub limit został osiągnięty",
        "Card is expired, lost or stolen": "Karta straciła ważność lub została oznaczona jako utracona",
        "Free tier users or one-time buyers": "Dla studentów, którzy kupili kurs używając płatności jednorazowych lub korzystających z kursów darmowych",
        "Additional HTML": "Dodatkowy kod HTML",
        "Additional navigation links": "Dodatkowe linki w nawigacji",
        "Mark transaction as revoked": "Oznacz transakcję jako odrzuconą",
        "Grant access": "Daj dostęp",
        "Revoke access": "Odbierz dostęp",
        "Ends at": "Data zakończenia",
        "Canceled at": "Data anulowania",
        "Skyier Subscription": "Dostęp do platformy Skyier",
        "Licence quantity": "Ilość licencji",
        "Price per licence": "Cena za licencję",
        "Activates when": "Aktywuje się przy ilości",
        "No additional licence pricing options yet": "Brak wariantów cenowych dla licencji",
        "Licence packages": "Pakiety licencji",
        "Manage access": "Zarządzaj dostępami",
        "If you want to participate - please add your email address below": "Jeśli chcesz mieć dostęp do kursu - dodaj swój adres email do listy",
        "Number of invites left": "Ilość pozostałych zaproszeń",
        "Invite": "Zaproś",
        "granted": "przyznano",
        "sent": "wysłano",
        "You have been invited": "Zaproszenie do platformy szkoleniowej",
        "Invitation": "Zaproszenie",
        "has invited you to watch": "zaprasza Cię do obejrzenia kursu online",
        "Click the button below and register. Access will be granted automatically": "Aby otrzymać dostęp, kliknij w poniższy przycisk i załóż konto. Dostęp zostanie przyznany automatycznie",
        "Multiple licences": "Wiele licencji",
        "Hide from view": "Ukryj na liście produktów",
        "Receipt as default": "Paragon gdy nie ma nipu",
        "Processing your payment": "Przetwarzanie płatności",
        "Wrong email or password": "Błędny email lub hasło",
        "Search": "Szukaj",
        "Search by code name": "Wpisz nazwę kodu",
        "Search by email": "Szukaj po adresach email",
        "No course filter": "Bez filtra kursów",
        "Validation errors. Please check if all the fields are correct.": "Sprawdź, czy wszystkie pola zostały wypełnione poprawnie i spróbuj ponownie.",
        "Sale error": "Wystąpił problem z dokonaniem płatności. Sprawdź czy dane karty są poprawne lub użyj innej karty.",
        "Single payments are enabled by default": "Model jednorazowych płatności jest włączony domyślnie.",
        "Integrated payment processing": "Integracja z systemami płatności",
        "Video embed": "Wideo embed",
        "Number of students who marked lecture as favorite": "Ilość osób, które oznaczyły lekcję jako ulubioną",
        "Number of comments": "Ilość komentarzy przy lekcji",
        "Number of students who marked lecture as completed": "Ilość osób, które oznaczyły lekcję jako ukończoną",
        "Full screen": "Pełna szerokość",
        "Contained": "Ograniczona szerokość",
        "Choose product": "Wybierz produkt",
        "Single payment products": "Produkty z pojedynczą płatnością",
        "od kwoty": "zniżki",
        "Small": "Mały",
        "off purchase": "rabatu",
        "Medium": "Średni",
        "Large": "Duży",
        "Url or embed link": "Link do wideo",
        "Size": "Rozmiar",
        "Promo limit": "Ilość produktów w cenie promocyjnej",
        "Promo code field": "Pole do wpisania kodu rabatowego",
        "Mode": "Tryb",
        "single": "pojedyncze",
        "all": "wszystko",
        "subscription": "subskrypcja",
        "Code expired": "Kod jest nieważny",
        "Invalid coupon code": "Nieprawidłowy kod",
        "Apply": "Aktywuj",
        "Have a promo code?": "Posiadasz kod rabatowy?",
        "Access time limit": "Limit dostępu do produktu - ilość dni",
        "Access date limit": "Limit dostępu do produktu - data",
        "How many days can students access this course": "Określa, ile dni studenci mogą korzystać z produktu po zakupie",
        "This is the date to which students can access this course": "Określa, do kiedy studenci mogą korzystać z produktu",
        "0 - no limits": "0 - nielimitowany dostęp",
        "Online course access:": "Dostęp do szkolenia online:",
        "Copy": "Kopiuj",
        "Share": "Udostępnij",
        "You are receiving this email because we received a password reset request for your account.": "Otrzymujesz tego e-maila, ponieważ zarejestrowaliśmy próbę odzyskania hasła.",
        "Reset password": "Zmień hasło",
        "Password reset notification": "Reset hasła",
        "Hello!": "Dzień dobry!",
        "If you’re having trouble clicking the \"{actionText}\" button, copy and paste the URL into your web browser: [{actionURL}]({actionURL})": "Jeśli występuje problem z kliknięciem w przycisk \"{actionText}\", skopiuj ten link do okna przeglądarki: [{actionURL}]({actionURL})",
        "Thank you for using our application!": "Miłego dnia!",
        "Subscriber status": "Status subskrybenta",
        "Retry": "Spróbuj ponownie",
        "No invoice integration": "Brak integracji z systemem do faktur",
        "Scheduled": "W toku",
        "Failed": "Błąd",
        "Affiliate": "Afiliacja",
        "Affiliate Codes": "Afiliacja",
        "Go to download": "Przejdź do pobierania",
        "Promo Codes": "Kody rabatowe",
        "Promo Code": "Kod rabatowy",
        "Invoice": "Faktura",
        "Product": "Produkt",
        "Students who bought this bundle will loose access to this course.": "Studenci, którzy kupili ten pakiet stracą dostęp do tego kursu.",
        "Bundle": "Pakiet",
        "Add bundle": "Dodaj pakiet",
        "Welcome message": "Wiadomość powitalna",
        "Manual invoices": "Manualne wystawianie faktur",
        "Total sales": "Całkowita sprzedaż",
        "Access to {name} - lifetime": "Dostęp do platformy {name} - nieograniczony",
        "Access to {name} - {number} month": "Dostęp do platformy {name} - {number} miesiąc",
        "Access to {name} - {number} months": "Dostęp do platformy {name} - {number} miesięcy",
        "Oops... No students match your search criteria.": "Ups... Nie znaleziono studentów spełniających kryteria wyszukiwania",
        "Your session has expired - please reload": "Sesja wygasła - proszę przeładuj stronę",
        "Single": "Jednorazowe",
        "Session expired": "Sesja wygasła",
        "Single Class": "Dostęp tylko do tego kursu",
        "All-Access Pass": "Dostęp do wszystkich kursów",
        "Log in to set progress": "Zaloguj się, aby oznaczyć lekcję jako ukończoną",
        "Please reload the page": "Przeładuj stronę, aby kontynuować",
        "Reload": "Przeładuj stronę",
        "No access": "Brak dostępu",
        "Purchase or log in to watch this lecture": "Zaloguj się lub wykup dostęp by oglądać",
        "Tags": "Tagi",
        "Removed": "Usunięto",
        "Tags assigned to this product": "Tagi przypisane do produktu",
        "Changed": "Zmieniono",
        "Rename": "Zmień",
        "Rename in all courses": "Zmień we wszystkich kursach",
        "Delete from all courses": "Usuń tag ze wszystkich kursów",
        "Added": "Dodano",
        "Public tags": "Tagi publiczne",
        "Watch": "Zobacz",
        "Get access": "Dołącz",
        "Full name": "Imię i nazwisko",
        "Free lecture": "Lekcja darmowa",
        "Add comment": "Dodaj komentarz",
        "Delete comment": "Usuń komentarz",
        "Want to see the comments?": "Chcesz zobaczyć komentarze?",
        "Send": "Wyślij",
        "Download": "Pobierz",
        "Prepare file for download": "Przygotuj plik do pobrania",
        "Total spend": "Suma wydatków",
        "No tags yet": "Brak tagów",
        "Sign in": "Zaloguj się",
        "Buy now": "Kup teraz",
        "Address 1": "Adres 1",
        "Users will onle be able to buy licences in packages": "Wymusza zakup licencji w pakietach. Przykładowo 10 licencji w pakiecie",
        "One user can buy multiple licences": "Jeden użytkownik może zakupić wiele licencji",
        "Address 2": "Adres 2",
        "More about this feature": "Więcej o tej funkcjonalności",
        "here": "tutaj",
        "Oops... Nothing here at the moment": "Ups... chwilowo nic tutaj nie ma",
        "Requires login": "Wymaga zalogowania",
        "This content is locked": "Treść zablokowana",
        "start learning": "Rozpocznij naukę",
        "Continue lerning": "Kontynuuj naukę",
        "Next": "Dalej",
        "Checklist": "Lista",
        "checklist": "Checklista",
        "Add new item": "Dodaj element",
        "Previous": "Wstecz",
        "Quiz question": "Pytanie typu quiz",
        "quiz": "pytanie",
        "Correct. Congratulations!": "Poprawna odpowiedź. Gratulacje!",
        "Wrong answer, please try again.": "Odpowiedź nie jest poprawna. Spróbuj ponownie.",
        "Check my answer": "Sprawdź",
        "Show tip": "Zobacz podpowiedź",
        "Correct answer": "Poprawna odpowiedź",
        "Add answer": "Dodaj odpowiedź",
        "Solution": "Rozwiązanie",
        "Transaction error, please try again": "Błąd przy przetwarzaniu transakcji, proszę spróbuj ponownie",
        "Log in or register": "Zaloguj się lub utwórz nowe konto",
        "Countdown": "Odliczanie",
        "Something went wrong": "Coś poszło nie tak",
        "Something went wrong. Please contact us.": "Coś poszło nie tak. Proszę skontaktuj się z nami.",
        "We haven't received a transaction confirmation yet.": "Niestety nie otrzymaliśmy potwierdzenia transakcji.",
        "Please check if the transaction registered in your bank account.": "Proszę sprawdź status transakcji w swoim banku i skontaktuj się z nami w razie jakichkolwiek wątpliwości.",
        "Time": "Godzina",
        "hours": "godziny",
        "minutes": "minuty",
        "seconds": "sekundy",
        "Go to conversation": "Przejdź do rozmowy",
        "Mark as unread": "Oznacz jako nieprzeczytane",
        "Mark as read": "Oznacz jako przeczytane",
        "Read": "Przeczytano",
        "Unread": "Nie przeczytano",
        "Create your first course": "Stwórz swój pierwszy kurs online",
        "Create your first article": "Stwórz swój pierwszy artykuł",
        "It's nice to meet you": "Miło nam Cię poznać",
        "This checklist is going to help you kickstart your course platform": "Poniższa checklista pomoże Ci wystartować z kursem online. Nie ma na co czekać, działaj!",
        "Want to switch plans? Let us know.": "Jeśli chcesz zmienić plan - napisz do nas.",
        "Can't find the right price? Please let us know what you need.": "Napisz nam, na jakich warunkach chcesz z nami współpracować. Razem na pewno znajdziemy optymalne rozwiązanie.",
        "Contact us": "Odezwij się do nas",
        "sale provision": "prowizji od sprzedaży",
        "Leads": "Leady",
        "No leads yet": "Brak leadów",
        "What makes Skyier special?": "Co nas wyróźnia?",
        "We care about your sales": "Twoja sprzedaż jest dla nas ważna",
        "We'll be happy to help you launch your online course": "Z chęcią pomożemy Ci w rozpoczęciu sprzedaży kursów online",
        "Skyier focuses on highly converting and performant sales page.": "Dbamy o wysoką konwersję Twoich stron sprzedażowych oraz prędkość ich ładowania. Więcej na ten temat przeczytasz",
        "We want to know your name": "Chcemy znać Twoje imię",
        "You're not going to be one of the countless anonymous clients. Our goal is to provide excellent quality of our service in every way possible. To do this - we will be limiting the number of clients that join Skyier.": "Nie będziesz jednym z tysiąca klientów. Naszym celem jest zapewnienie bardzo wysokiej jakości obsługi i stabilności działania platformy. Aby móc to zrobić, świadomie ograniczamy naszą ilość klientów.",
        "You are the one leading the way": "Stawiamy na rozwój dopasowany do Twoich potrzeb",
        "Anytime you notice something is missing or off, let us know about it. We will be happy to help.": "Jeśli brakuje Ci czegoś w platformie. Napisz do nas, umówimy się na rozmowę i porozmawiamy o efektach, jakie chcesz osiągnąć i funkcjach, które uważasz, że mogą Ci w tym pomóc.",
        "Always speak directly with the decision-makers": "Zawsze masz kontakt z osobami decyzyjnymi",
        "Rest assured that Natalia and Maciej are on the front lines and they will be the ones to contact you whenever you need anything.": "Możesz mieć pewność, że osobami, które będą Cię obsługiwały będziemy my: Natalia i Maciek. A ewentualne błędy techniczne będą nas bardziej stresować niż Ciebie i nie usłyszysz odpowiedzi: “Twoje zgłoszenie zostało przyjęte. Numer zgłoszenia to 23777. Odpowiedź zostanie udzielona w ciągu 48h”.",
        "We are going to help you succeed": "Pomagamy Tobie w optymalizacji stron sprzedażowych",
        "We want you to succeed! So whenever you need any help, guidance or advice - you can count on our experience in sales page optimization.": "Bo chcemy, abyś sprzedawał więcej! Jak to wygląda? Jeśli będziesz potrzebował naszego wsparcia, umawiasz się z nami na rozmowę online. Razem audytujemy Twoją stronę i oceniamy co można ewentualnie poprawić. Maciek bardzo chętnie swoją wiedzę zdobytą przez 6 lat w pracy przy optymalizacji stron zastosuje u Ciebie.",
        "Sales page inspiration": "Inspiracje stron sprzedażowych",
        "Free trial takes as long as you need": "Testuj tak długo, jak tego potrzebujesz",
        "Optimised hosting": "Zoptymalizowany hosting",
        "Secure payment methods": "Bezpieczne metody płatności",
        "Updates": "Aktualizacje",
        "Security": "Bezpieczeństwo",
        "Lecture delay feature": "Opóźnianie lekcji",
        "Best in class conversion optimisation": "Optymalizacja konwersji na najwyższym poziomie",
        "Lead generation / presale": "Generowanie leadów / przedsprzedaż",
        "Webhooks": "Webhooki",
        "Invoicing systems": "Systemy do fakturowania (InFakt, Fakturownia, IFirma)",
        "Analytics": "Analityka",
        "Payment systems (PayPal, Braintree, PayU, PayLane)": "Systemy płatności (PayPal, Braintree, PayU, PayLane)",
        "All features enabled": "Wszystkie funkcje",
        "Other JavaScript codes": "Dowolny kod JavaScript",
        "We build Skyier with the same level of engagement as you are build your online business. All we want is to have satisfied customers who love Skyier. We will be very happy if you decide to publish your online course using Skyier.": "Jesteśmy osobami, które podobnie jak Ty z wielkim zaangażowaniem budują swój biznes online. Naszym celem jest posiadanie 100% zadowolonych klientów. Mamy nadzieję, że zostaniesz jednym z nich! Będzie nam naprawdę bardzo przyjemnie, jeśli zaczniesz sprzedawać swoje kursy online właśnie z nami.",
        "I don't like wasting time to unnecessary bureaucracy. I find Skyier the perfect platform to sell online courses": "Bardzo nie lubię tracić czasu na formalności. Skyier to dla mnie idealna platforma do sprzedaży kursów",
        "If you're looking for a solution to sell online courses, Skyier is a way to go.": "Jeśli szukasz rozwiązania do sprzedaży kursu online to serdecznie polecam Skyier.",
        "There's way more...": "I wiele, wiele więcej...",
        "photographer, marketing specialist": "fotograf, szkoleniowiec",
        "The course platform, your students will love": "Platforma do kursów online, którą pokochają Twoi klienci",
        "Stand out with your brand": "Wyróżnij się wizerunkiem",
        "Create beautiful websites using simple and intuitive tools": "Stwórz piękną stronę za pomocą prostych i intuicyjnych narzędzi",
        "Put your students first": "Postaw na wygodę uczestników",
        "Create motivating and engaging environment for your students to learn": "Zapewnij im przyjemną, efektywną i angażującą naukę",
        "Build relations using data": "Analizuj i buduj relacje",
        "Use engagement data to build meaningful, long term relations": "Rozwijaj biznes na podstawie zachowania uczestników",
        "Create enjoyable learning environment for your students": "Podaruj uczestnikom przyjemne miejsce do nauki",
        "Allow students to build relations with you and with each other": "Poznawaj opinie uczestników i pozwól im budować relacje między sobą i z Tobą",
        "Your students can mark lectures as favorites": "Daj uczestnikom możliwość oznaczania wybranych lekcji jako ulubione i wiedz, które tematy są najbardziej popularne",
        "Notes": "Notatki",
        "Your students can make notes to your lectures": "Umożliwiaj uczestnikom robienie notatek w czasie nauki i zwiększaj ich efektywność",
        "Optimised payment page": "Zoptymalizowana strona płatności",
        "Simple and easy way to make payments": "Uprzyjemnij i usprawnij sposób dokonywania płatności za swój kurs",
        "Turn your knowledge into a beautiful course": "Zamień swoją wiedzę we wspaniały kurs online",
        "Create engaging lectures using videos, audios, pdfs and texts": "Twórz anagażujące lekcje za pomocą wideo, audio, pdf i tekstów",
        "Videos, audios, pdfs and texts": "Wideo, audio, pdf, tekst",
        "Sales pages": "Strony sprzedażowe",
        "Create visually appealing landing pages inside Skyier or connect your already existing website": "Buduj przejrzyste landing page do sprzedaży kursu online lub podepnij swoją stronę",
        "Publish your courses on your own domain": "Publikuj kursy pod swoją domeną lub subdomeną",
        "Statistics": "Statystyki",
        "Learn which lectures are the most engaging and act on it": "Dowiedz się, które lekcje najbardziej angażują do dyskusji, ilu masz uczestników kursu i ile zarobiłeś",
        "Sample sales pages made with Skyier": "Przykładowe strony do sprzedaży Twojego kursu online",
        "Enable marketing aggrement": "Wyświetlaj checkbox ze zgodą marketingową",
        "Marketing aggrement text": "Treść zgody marketingowej",
        "Thank you for leaving your contact information": "Dziękuję za pozostawienie danych kontaktowych",
        "Go back": "Wróć do poprzedniej strony",
        "Submit": "Wyślij",
        "Lead generation": "Zbieranie leadów",
        "Add note": "Dodaj notatkę",
        "Want to make notes?": "Chcesz dodać notatkę?",
        "Stats": "Statystyki",
        "Subscribe to": "Dołącz do",
        "Discount": "Rabat",
        "Total": "Do zapłaty",
        "Remove from favorites": "Usuń z ulubionych",
        "Add to favorites": "Dodaj do ulubionych",
        "No favorites yet": "Nie dodałeś jeszcze ulubionych lekcji",
        "Favorites": "Ulubione",
        "Oops... No comments yet": "Ups... Brak komentarzy",
        "Oops... No transactions yet": "Ups... Brak transakcji  ",
        "Oops... No students yet": "Ups... Brak uczestników",
        "You need to write something!": "Nie może być pusty!",
        "Enter title": "Tytuł",
        "Lecture created": "Lekcja dodana",
        "Take the first step and click ADD COURSE": "Zrób ten pierwszy krok i kliknij DODAJ KURS!",
        "Required to create your profile on the platform": "Potrzebne do utworzenia Twojego profilu na platformie",
        "Did you encourage students in the course to respond?": "Czy zachęcałeś w kursie uczestników do udzielania odpowiedzi?",
        "Start sharing knowledge on your blog!": "Zacznij dodatkowo dzielić się wiedzą na swoim blogu!",
        "Have you defined your target group well and you have enough website traffic?": "Czy na pewno dobrze określiłeś swoją grupę docelową i masz wystarczający ruch na swojej stronie?",
        "Do you need help optimizing your sales page?. Contact us!": "Czy potrzebujesz pomocy w optymalizacji Twojej strony sprzedażowej? Skontaktuj się z nami!",
        "Loading": "W toku",
        "Warning": "Uwaga",
        "Draft": "Szkic",
        "Updated": "Zapisano",
        "My courses": "Moje kursy",
        "Learning platform access": "Dostęp do platformy szkoleniowej",
        "All courses": "Wszystkie kursy",
        "External sales pages": "Zewnętrzne strony sprzedażowe",
        "Student has updated his account settings": "Zmiana ustawień konta studenta",
        "Comment feed": "Wszystkie komentarze",
        "European VAT Number or empty value": "NIP w formacie międzynarodowym lub puste pole",
        "Incorect VAT Number format": "Nieprawidłowy format numeru NIP",
        "Only letters and numbers. Example: PL1234567890": "Tylko litery i cyfry. Przykład: PL1234567890",
        "Disable comments": "Wyłącz komentarze",
        "Enable comments": "Włącz komentarze",
        "Comments enabled": "Komentarze włączone",
        "Comments disabled": "Komentarze wyłączone",
        "Agreement": "Zgody",
        "The password must be at least 6 characters.": "Hasło musi mieć co najmniej 6 znaków.",
        "Order Summary": "Podsumowanie",
        "VAT UE": "NIP (VAT UE)",
        "If this is not you, please use a different email address.": "Jeśli to nie Twój adres email - proszę użyj innego.",
        "Payment information": "Dane do płatności",
        "Receipt information": "Dane do potwierdzenia zakupu",
        "to reset it": "aby je zresetować",
        "click here": "kliknij tutaj",
        "Welcome back. Looks like you already have an account.": "Witaj ponownie. Wygląda na to, że masz już konto.",
        "If you forgot your password": "Jeśli nie pamiętasz hasła",
        "terms": "regulaminem",
        "privacy policy": "polityką prywatności",
        "By signing up I agree to the": "Rejestrując się potwierdzasz, że zapoznałeś się z",
        "I want to receive newsletters and special offer notices.": "Wyrażam zgodę na otrzymywanie newslettera oraz innych informacji handlowych.",
        "This is a secure 128-bit SSL encrypted payment": "Płatność chroni 128 bitowe szyfrowanie SSL",
        "First name here": "Imię tutaj",
        "This component is not available in preview mode": "Ten komponent nie wyświetla się w trybie podglądu",
        "Confirm password": "Potwierdź hasło",
        "Enter password": "Wprowadź hasło",
        "Logged in as": "Zalogowany jako",
        "Continue": "Kontynuuj",
        "Choose country": "Wybierz kraj",
        "Account information": "Konto",
        "Preview": "Podgląd",
        "Engage your students in meaningfull discussions.": "Angażuj uczestników w dyskusję na temat Twojego kursu i zbieraj feedback.",
        "Be first to comment": "Bądź pierwszy, który skomentuje",
        "Comments": "Komentarze",
        "Comment": "Komentarz",
        "Edit comment": "Edytuj komentarz",
        "Post a comment": "Skomentuj",
        "Post Comment": "Dodaj komentarz",
        "Leave a comment...": "Treść komentarza tutaj...",
        "Discussion": "Dyskusja",
        "Back": "Powrót",
        "Enroll in course to unlock": "Kup kurs i rozpocznij naukę!",
        "Enroll": "Dołącz",
        "Example": "Przykład",
        "Sample platform": "Przykładowa platforma",
        "File name": "Nazwa pliku",
        "Transaction processing...": "Przetwarzanie transakcji...",
        "Pay using PayU": "Płacę z PayU",
        "Watch Course": "Oglądaj teraz",
        "Add new component": "Dodaj komponent",
        "Question": "Pytanie",
        "Answer": "Odpowiedź",
        "Additional lecture content": "Plik z materiałami",
        "Header": "Nagłówek",
        "Left": "Lewa",
        "Right": "Prawa",
        "Side image": "Tekst ze zdjęciem",
        "Add": "Dodaj",
        "promo code": "kod promocyjny",
        "Remove image": "Skasuj zdjęcie",
        "Columns": "Kolumny",
        "Image": "Zdjęcie",
        "image": "zdjęcie",
        "Upload completed": "Ładowanie pliku zakończone",
        "Enroll in Course for": "Kupuję teraz za",
        "Enroll in Course": "Dołącz do kursu",
        "Quote here": "Tutaj cycat",
        "Quote source": "Źródło",
        "Name here": "Nazwa / Imię",
        "Add new quote": "Dodaj nowy cytat",
        "Created at": "Data utworzenia",
        "Affiliate tag": "Afiliacja",
        "Network error": "Problem z połączeniem",
        "Banner": "Baner",
        "Edit home page": "Edytuj stronę główną",
        "Block order updated": "Kolejność bloków zmieniona",
        "Sales page": "Strona sprzedażowa",
        "Button": "Przycisk",
        "Quote": "Opinia",
        "Product list": "Lista produktów",
        "Add new block": "Dodaj nową sekcję",
        "Edit page content": "Edytuj wygląd strony",
        "Available {days} days after you enroll": "Lekcje będą dostępne {days} dni po zakupie",
        "This lecture is not yet available": "Ta lekcja nie jest jeszcze dostępna",
        "This lecture will be available on": "Lekcja zostanie odblokowana w dniu:",
        "Lectures in this section will be available for your students x days after purchase.": "Lekcje wchodzące w skład tej sekcji będą dostępne dla studentów x dni po zakupie.",
        "Section available after": "Lekcje dostępne po",
        "Delay": "Opóźnienie",
        "Delay section by days:": "Sekcja będzie dostępna po następującej liczbie dni:",
        "days": "dni",
        "Class Curriculum": "Lekcje wchodzące w skład kursu",
        "Edit component": "Edytuj komponent",
        "Delete component": "Usuń komponent",
        "Upload failed": "Wgrywanie pliku nie powiodło się",
        "Bad file extension": "Złe rozszerzenie pliku",
        "Lectures": "Lekcje",
        "Create lecture": "Dodaj lekcję",
        "Add components": "Dodaj komponent",
        "Choose video file": "Wgraj plik video",
        "Choose file": "Wybierz plik",
        "or drag it here": "lub przeciągnij tutaj",
        "Add component": "Dodaj komponent",
        "Manage components": "Zarządzaj komponentami",
        "Lecture": "Lekcja",
        "Lectures list": "Lista lekcji",
        "Video": "Wideo",
        "video": "wideo",
        "Text": "Tekst",
        "text": "tekst",
        "number": "cyfra",
        "text area": "tekst (długi)",
        "File": "Plik",
        "file": "plik",
        "User has to sign up and log in to view content": "Użytkownik musi założyć konto lub zalogować się, aby obejrzeć kurs",
        "Edit title": "Edytuj tytuł",
        "Component updated": "Komponent został zaktualizowany",
        "Type DELETE to confirm": "Wpisz DELETE, aby potwierdzić usunięcie",
        "Component deleted": "Komponent został usunięty",
        "Text component created": "Komponent tekstowy został utworzony",
        "Component created": "Komponent został utworzony",
        "Component order updated": "Kolejność komponentów została zaktualizowana",
        "Lecture updated": "Zmiany zostały zapisane",
        "New lecture": "Tytuł lekcji tutaj",
        "Set as free to watch": "Ustaw jako darmową",
        "Set as paid": "Ustaw jako płatną",
        "Set - available after login": "Ustaw, aby oglądanie było dostępne po zalogowaniu",
        "Set - available without login": "Ustaw, aby oglądanie było dostępne bez logowania",
        "Section order updated": "Kolejność została zaktualizowana",
        "Lecture order updated": "Kolejność lekcji została zaktualizowana",
        "Lecture is free to watch": "Lekcja jest dostępna do obejrzenia za darmo",
        "Lecture requires payment": "Lekcja jest możliwa do obejrzenia po dokonaniu płatności",
        "Lecture requires login": "Lekcja wymaga zalogowania, aby obejrzeć",
        "Lecture does not require login": "Lekcja nie wymaga zalogowania, aby obejrzeć",
        "Lecture published": "Lekcja została opublikowana",
        "Lecture unpublished": "Lekcja została odpublikowana",
        "Section updated": "Zmiany zostały zapisane",
        "Title can not be empty": "Tytuł nie może być pusty",
        "Section title can not be empty": "Tytuł sekcji nie może być pusty",
        "Section created": "Nowa sekcja została utworzona",
        "Section deleted": "Seksja została usunięta",
        "Lecture deleted": "Lekcja została usunięta",
        "Section title here": "Tutaj dodaj tytuł",
        "Add section": "Dodaj sekcję",
        "Delete section": "Usuń sekcję",
        "Delete lecture": "Usuń lekcję",
        "Edit section title": "Edytuj tytuł sekcji",
        "Add lecture": "Dodaj lekcję",
        "Something went wrong. Please check your balance and try again later.": "Coś poszło nie tak w procesie płatości. Sprawdź balans konta i spróbuj ponownie później.",
        "Ready to get started?": "Gotowy by zacząć?",
        "Create an account!": "Załóż konto!",
        "Create an account": "Załóż konto",
        "Selling courses online was never this easy!": "Sprzedaż kursów online jeszcze nigdy nie była taka prosta!",
        "Please drop us a line inside the chat window whenever you need anything. We'll be happy to help!": "Jeśli czegoś potrzebujesz - napisz do nas!",
        "Share your written content as text lectures.": "Dziel się swoją wiedzą w formie lekcji tekstowych.",
        "Add as much video content as you want. No limits here.": "Dodawaj nieograniczoną ilość wideo przy każdym kursie. Nie masz tutaj żadnych limitów.",
        "Integrate with whatever you want using webhooks. Example: send data to Zapier and then process it however you want.": "Zintegruj się z Zapierem, własnym serwisem lub innymi serwisami i zarządzaj swoimi danymi.",
        "Add Google Tag Manager, Google Analytics, Facebook Pixel or other javascript code.": "Podepnij swój kod Google Analytics, Google Tag Manager, Pixel Facebooka lub inny kod JavaScript.",
        "Automate your workflow. Current invoicing systems available: IFirma, inFakt, Fakturownia. Need something else? Let us know!": "Zautomatyzuj proces wystawiania faktur. Obecnie jesteśmy zintegrowani z takimi systemami jak: IFirma, InFakt, Fakturowania. Jeśli nie posiadamy Twojego systemu, napisz do nas!",
        "Choose your payment provider. Currently available: Paylane, PayU, PayPal, Braintree. Need something else? Let us know!": "Wybierz swój system płatności. Obecnie, jesteśmy zintegrowani z Paylane, PayU, PayPal, Braintree. Jeśli nie posiadamy Twojego systemu, napisz do nas!",
        "Publish courses under your own domain or subdomain.": "Publikuj kursy pod swoją domeną lub subdomeną. Bez problemu możesz podpiąć platformę pod swoją stronę.",
        "You have full control. You can enable and disable access for each student if you need to.": "Masz pełną kontrolę nad swoim kursem. Bez problemu możesz nadać lub cofnąć dostęp studentowi, jeśli uznasz to za konieczne.",
        "You can decide if you want to distribute your course for free to get leads or you want to get paid.": "Możesz zdecydować jaki status mają mieć Twoje poszczególne kursy. Twórz kursy płatne i zarabiaj pieniądze. Udostępniaj kursy bezpłatne i generuj leady.",
        "Your site is optimized for speed and conversion. It means they are great for your students and Google.": "Twoje strony są bardzo dobrze zoptymalizowane pod SEO i SEM. Zapewniamy m.in. optymalizację serwera, kompresję kodu i ładowanie grafik w oparciu o lazy loading.",
        "Create content to increase the SEO potential and nurture your students.": "Twórz content, aby zwiększyć potencjał SEO strony, zbudować pozycję eksperta oraz zdobywać uczestników kursów online.",
        "Blog will help you bring more SEO traffic": "Blog pomoże Ci zdobyć dodatkowy ruch z SEO",
        "Pdf file upload": "Wgrywanie plików pdf",
        "Delay lectures": "Opóźnianie lekcji",
        "Share lectures with delay and control the learning process of your students.": "Udostępniaj lekcje z opóźnieniem i kontroluj proces nauki swoich studentów.",
        "Add pdf file to your lectures and enrich your courses with additional materials.": "Dodawaj pliki pdf do swoich lekcji i wzbogacaj kursy dodatkowymi materiałami szkoleniowymi.",
        "Text lectures": "Lekcje tekstowe",
        "With the ability to link PDF's": "Z możliwością linkowania plików PDF",
        "Description will be displayed as a lead text on the episodes list": "Tekst będzie widoczny jako zajawka na liście lekcji.",
        "Text episode created": "Lekcja tekstowa została stworzona",
        "How do we manage our online business in a nutshell?": "Jak rozwijamy platformę do sprzedaży kursów?",
        "How to get your first clients? How to distinguish from the competition? You will find out what we did from the articles on our blog": "Jak zdobyliśmy pierwszego klienta? Czy zrobiliśmy badanie rynku? Na te i inne pytania znajdziesz odpowiedzi na naszym blogu.",
        "How to sell more online courses?": "Jak sprzedawać kursy online?",
        "We have analyzed hundreds of course selling strategies to help you grow.": "Skorzystaj z naszej bazy artykułów i dowiedz się jak zwiększyć sprzedaż swoich kursów online.",
        "Our jurney from 0 to $10 000 in monthly revenue": "Nasza podróż od 0 do 10 000 zł miesięcznego przychodu",
        "Course Description": "Opis Kursu",
        "articles": "artykuły",
        "Resources": "Wiedza",
        "Free resources to help you grow :)": "Chcemy pomóc Ci rosnąć. Dlatego piszemy dla Ciebie",
        "Student transactions": "Transakcje studenta",
        "Course Details": "Opcje Kursu",
        "Episode Description": "Opis Lekcji",
        "Episode Details": "Opcje Lekcji",
        "for non subscribers": "dla osób, które użyły płatności jednorazowych",
        "for subscribers": "dla subskrybentów",
        "See sample page": "Jak może wyglądać Twoja strona",
        "Published": "Opublikowany",
        "Invoice Integration": "Integracja z systemem do faktur",
        "Payment Provider": "System do obsługi płatności",
        "Payment Provider / Membership": "System do obsługi płatności subskrypcyjnych",
        "Not published": "Nie opublikowany",
        "Sales": "Sprzedaż",
        "Payment pending": "Transakcja oczekuje na zakończenie",
        "Your transaction is PENDING.": "Twoja transakcja ma status PENDING (oczekuje)",
        "We will check the status of your transaction every 5 minutes.": "Będziemy sprawdzać jej status co pięć minut.",
        "Once your transaction is completed, you will gain access to your course.": "Kiedy transakcja zostanie zakończona - uzyskasz dostęp do kursu.",
        "You can refresh this page later. Once your transaction is completedyou you will be redirected to your course (on refresh)": "Możesz za jakiś czas odświeżyć tę stronę. Jeśli transakcja będzie zakończona - zostaniesz przekierowany do Twojego kursu.",
        "About us": "O nas",
        "Account settings": "Ustawienia konta",
        "Add a domain": "Dodaj domenę",
        "Add episode": "Dodaj lekcję",
        "Add your first course": "Dodaj swój pierwszy kurs",
        "Adding a free course": "Dodawanie kursów darmowych",
        "Address": "Adres",
        "Advanced": "Zaawansowany",
        "Already have an account? Log in": "Masz już konto? Zaloguj się",
        "Already have an account?": "Masz już konto?",
        "Amount": "Ilość",
        "Value": "Wartość",
        "The date from which the sales limit will be calculated": "Data, od której będzie liczony limit sprzedaży",
        "Are you sure?": "Czy jesteś pewien?",
        "Author avatar": "Zdjęcie autora",
        "Authors bio": "O autorze",
        "Authors contact email": "E-mail kontaktowy do autora",
        "Authors name": "Autor",
        "Balance": "Bilans",
        "Balance and payment": "Bilans konta i wypłata",
        "Balance and withdrawal": "Bilans konta i wypłata",
        "Bank account": "Numer konta bankowego",
        "Before you start adding an online course, connect your domain. If in doubt, please watch our tutorial or contact us: hello@skyier.com.": "Zanim zaczniesz dodawać swój kurs, podłącz domenę. W razie wątpliwości, obejrzyj proszę naszą instrukcję wideo lub napisz do nas: hello@skyier.com.",
        "Before you start selling": "Zanim zaczniesz sprzedawać",
        "Begginer": "Początkujący",
        "Benefits here": "Tutaj wymień korzyści",
        "Billing information": "Informacje do wystawienia faktury",
        "Buy Now": "Kup teraz",
        "By signing up, you agree to our": "Rejestrując się, akceptujesz",
        "Cancel": "Anuluj",
        "Card": "kartą",
        "Card Number": "Numer karty",
        "Card number": "Numer karty",
        "Category": "Kategoria",
        "Changes saved": "Zmiany zostały zapisane",
        "Saved": "Zapisano",
        "Choose option": "Wybierz opcję",
        "City": "Miasto",
        "All access": "Dostęp do wszystkich kursów",
        "Get started": "Zacznij teraz",
        "Remove invalid records and try again": "Usuń niepoprawne rekordy i spróbuj ponownie",
        "Subscription restricted access": "Dostęp na czas trwania subskrypcji",
        "monthly": "miesięcznie",
        "quarterly": "kwartalnie",
        "half yearly": "półrocznie",
        "yearly": "rocznie",
        "annually": "rocznie",
        "one time": "jednorazowo",
        "forever": "na zawsze",
        "Click Save to see additional options here": "Kliknik Zapisz, aby zobaczyć dodatkowe opcje",
        "Company": "Firma",
        "Person": "Osoba fizyczna",
        "Company name": "Nazwa firmy",
        "Company name / Name": "Nazwa firmy / Imię i nazwisko",
        "Confirm Password": "Potwierdź hasło",
        "Connect domain": "Podepnij domenę",
        "Contact": "Kontakt",
        "Country": "Kraj",
        "Course": "Kurs",
        "Courses": "Kursy",
        "Cover photo": "Zdjęcie główne",
        "Add course": "Dodaj kurs",
        "Create": "Utwórz",
        "Created": "Element został stworzony poprawnie",
        "Credit card information": "Dane karty kredytowej",
        "Currency": "Waluta",
        "Custom domain name": "Własna domena",
        "Date": "Data",
        "Delete": "Usuń",
        "Deleted": "Usunięto",
        "Turn your knowledge into a profitable business!": "Zacznij zarabiać na swojej wiedzy. Zbuduj dochodowy biznes online!",
        "Delight your students with an awesome online content. With Skyier it is really that easy! Get to know our solution!": "Zachwyć studentów swoim szkoleniem online. Zacznij rozwijać swój biznes razem ze Skyier.",
        "Description": "Opis",
        "Description here": "Tutaj dodaj opis",
        "Details": "Szczegóły",
        "Difficulty": "Poziom trudności",
        "Do you realy want to delete this element?": "Wybierając opcję Usuń, zgadzasz się na usunięcie tego elementu w całości",
        "Domain": "Domena",
        "Domain verification in progress": "Trwa weryfikacja domeny",
        "E-Mail Address": "Adres e-mail",
        "Ease of use": "Przyjemne budowanie i rozwijanie biznesu",
        "Edit": "Edytuj",
        "Edit course": "Edytuj kurs",
        "Email": "E-mail",
        "email": "e-mail",
        "Email support": "Wsparcie poprzez e-mail",
        "Episode": "Lekcja",
        "Episode length in seconds.": "Czas trwania lekcji podany w sekundach.",
        "Episodes": "Lekcje",
        "Episodes list": "Lista lekcji",
        "Episodes order saved successfully": "Kolejność lekcji została zapisana",
        "Order updated": "Kolejność zmieniona",
        "Error": "Błąd",
        "example": "przykład",
        "example: Skyier": "przykład: Skyier",
        "example: courses.skyier.com": "przykład: kursy.skyier.com",
        "courses.skyier.com": "kursy.skyier.pl",
        "Expiration Date": "Data ważności",
        "Month": "Miesiąc",
        "Year": "Rok",
        "Expiry month": "Miesiąc/ważność",
        "Expiry year": "Rok/ważność",
        "Start selling ASAP": "Szybkie rozpoczęcie sprzedaży kursów online",
        "Fill out your Account settings": "Uzupełnij dane w Ustawieniach konta",
        "Fill out your Page settings": "Uzupełnij dane w Ustawieniach strony",
        "First name": "Imię",
        "Active": "Aktywny",
        "Promo codes": "Kody promocyjne",
        "Ordering as": "Zamawiam jako",
        "How to get Mailchimp API KEY": "Gdzie znaleźć API KEY",
        "How to find Mailchimp List ID": "Gdzie znaleźć List ID",
        "Additionaly, list needs to have FNAME merge tag to work properly.": "Lista musi posiadać pole FNAME (merge tag), aby działać prawidłowo.",
        "Settings": "Ustawienia",
        "Notification preferences": "Ustawienia powiadomień",
        "Focus on what matters most. Build relationships with your audience, create more content, do whatever you think is most important. Skyier will take care of all the technical and visual aspects of your site.": "Wykorzystuj swoje kursy online, webinary czy artykuły do generownia nowych leadów. Zamieniaj pozyskane kontakty w swoich klientów i zwiększaj sprzedaż!",
        "Forgot Your Password?": "Zapomniałeś hasła?",
        "Fortunately, there is a simple solution. You can buy the access to this lecture and all other lectures inside this course.": "Jednak szybko możesz to zmienić. Kupując kurs otrzymasz możliwość obejrzenia tej lekcji oraz wszystkich pozostałych.",
        "Fortunately, there is a simple solution. You can watch this episode and all the other episodes in this course for": "Jednak szybko możesz to zmienić. Kupując kurs, otrzymasz możliwość obejrzenia tej lekcji oraz wszystkich pozostałych za",
        "Special offer": "Promocja",
        "Free": "Darmowy",
        "Free SSL certificate": "Darmowy certyfikat SSL",
        "More": "Więcej",
        "Go to payment": "Przejdź do płatności",
        "Go to summary": "Przejdź do podsumowania",
        "Go to settings": "Przejdź do ustawień",
        "Got it!": "OK",
        "Have an account?": "Masz konto?",
        "Home": "Strona główna",
        "How to start?": "Co musisz zrobić?",
        "If you wish to cancel your subscription or change your card details. Please email us.": "Jeśli chcesz zrezygnować z subskrypcji lub chcesz zmienić dane karty - napisz do nas.",
        "If you wish to cancel your subscription or change your card details. Please email us: hello@skyier.com.": "Jeśli chcesz anluować swoją subskrypcję lub zmieni dane karty kredytowej, proszę napisz do nas na: hello@skyier.com.",
        "Instructor panel settings": "Ustawienia panelu instruktora",
        "Integrate payment system": "Zintegruj wybrany system płatności",
        "Payment processing": "Integracje z systemami płatności",
        "Intermediate": "Średniozaawansowany",
        "It changes based on the number of transactions.": "Kwota ta jest zmienna. Bazuje na ilości transakcji.",
        "Language": "Język",
        "Language of your admin panel.": "Język twojego panelu administracyjnego.",
        "Last charge was not successful. Please check your account balance and the validity of your card.": "Ostatnia próba pobrania nie powiodła się. Prosimy o sprawdzenie czy na koncie są wystarczające środki.",
        "Last name": "Nazwisko",
        "Learn more": "Dowiedz się więcej",
        "Lessons": "Lekcje",
        "Start your subscription": "Rozpocznij subskrypcję",
        "Update card or subscription": "Aktualizuj kartę lub zmień plan",
        "Log in": "Zaloguj się",
        "Latest": "Nowe",
        "Latest activity": "Ostatnia aktywność",
        "Log in now": "Zaloguj się",
        "Login": "Logowanie",
        "Login is temporarily disabled": "Logowanie jest chwilowo niedostępne",
        "Logout": "Wyloguj",
        "Looks like this card number has an error.": "Upewnij się, że numer karty jest poprawny",
        "Max: 150 characters, including spaces.": "Maks: 150 znaków ze spacją.",
        "Max: 70 characters, including spaces.": "Maks: 70 znaków ze spacją.",
        "More time for yourself": "Efektywne generowanie leadów poprzez edukcję",
        "Name": "Imię",
        "Name on card": "Imię i nazwisko widniejące na karcie",
        "Next charge amount": "Kwota kolejnego pobrania",
        "Next credit card charge": "Następne pobranie",
        "No": "Nie",
        "No transaction fee on free courses": "Brak prowizji od kursów darmowych",
        "No account yet?": "Nie masz jeszcze konta?",
        "No courses yet": "Brak kursów",
        "Skyier has everything you need to start your online business. All you have to do is to connect your domain and payment provider.": "Tylko kilka minut! Tyle zajmuje przygotowanie platformy do sprzedaży kursów online. Platformy zautomatyzowanej pod względem płatności, wystawiania faktur i wysyłania mailingu.",
        "No transactions available": "Żadna transkacja nie została zrealizowana. Brak możliwości dokonania wypłaty",
        "No transactions yet": "Brak transakcji",
        "No video yet": "Brak wideo",
        "OK": "OK",
        "One plan to rule them all": "Jeden plan, bo tak jest prościej",
        "Integration settings": "Ustawienia integracji",
        "Page language": "Język strony",
        "Page name": "Nazwa strony",
        "Page settings": "Ustawienia strony",
        "Page version for students.": "Wersja strony widoczna dla studentów.",
        "Password": "Hasło",
        "Pay": "Zapłać",
        "Pay with": "Zapłać",
        "Payment": "Dokonanie płatności",
        "Payment Information": "Zapłata",
        "Payment processing fees": "Całkowity koszt obsługi transkacji",
        "Payment provider": "System płatności",
        "Payment successful!": "Płatność zakończona sukcesem!",
        "Payment failed": "Płatność nie została zrealizowana",
        "Plan includes": "W plan wchodzi",
        "Please check your credit card information. Looks like there is something missing.": "Sprawdź czy wszystkie dane z karty zostały wpisane poprawnie.",
        "Please contact": "Proszę skontaktuj się z",
        "Poland": "Polska",
        "Postal code": "Kod pocztowy",
        "Powered by": "Wspierane przez",
        "Price": "Cena",
        "Limited offer": "Cena promocyjna",
        "Available promotional packages": "Ilość dostępnych pakietów promocyjnych",
        "Prices do not include VAT, which may have to be added, depending on the country where the service recipient has his registered office.": "Ceny nie zawierają podatku VAT, który może zostać doliczony, w zależności od kraju, w którym usługobiorca ma swoją siedzibę.",
        "Promotional packages limit": "Limit pakietów promocyjnych",
        "End date is before the start date": "Data końca jest przed datą startu",
        "-1 = infinite number of promo packages": "-1 oznacza nieskończoną ilość dostępnych produktów w cenie promocyjnej. Promocja kończy się w chwili, kiedy wszystkie pakiety promocyjne zostaną sprzedane lub data końcowa zostanie osiągnięta. Wówczas automatycznie pojawi się cena standardowa.",
        "Promo ends": "Koniec promocji",
        "Promo starts": "Początek promocji",
        "Has promotion": "W promocji",
        "Promo price": "Cena promocyjna",
        "Price in cents. Without spaces, commas or dots.": "Cena podana w groszach. Bez spacji, przecinków i kropek.",
        "Privacy": "Polityka prywatności",
        "Privacy Policy": "Politykę Prywatności",
        "Problem during the verification process": "Został zanotowany problem w czasie weryfikacji domeny.",
        "Publish": "Publikuj",
        "Redirect your domain": "Przekieruj swoją domenę",
        "Register": "Zarejestruj",
        "Register now.": "Zarejestruj się.",
        "Registration is temporarily disabled": "Rejestracja jest chwilowo niedostępna",
        "Remember Me": "Zapamiętaj mnie",
        "How to redirect your domain?": "Jak przekierować domenę?",
        "Reset Password": "Zresetuj hasło",
        "Result": "Wynik",
        "Top": "Góra",
        "Bottom": "Dół",
        "Run time": "Czas trwania",
        "SEO description": "Opis SEO",
        "SEO title": "Tytuł SEO",
        "3ds authentication process failed": "Wytąpił błąd podczas autoryzacji karty (zabezpieczenie 3ds)",
        "Save": "Zapisz",
        "Code": "Kod",
        "code": "kod",
        "Save episode order": "Zapisz kolejność lekcji",
        "Overlay color": "Kolor tła",
        "Security Code": "Kod bezpieczeństwa",
        "Send Password Reset Link": "Wyślij link do resetu hasła",
        "Seo description here": "Tutaj dodaj opis SEO",
        "Seo title here": "Tutaj dodaj tytuł SEO",
        "Limited time offer": "Oferta ograniczona czasowo",
        "Separate using new line.": "Rozdziel tekst używając nowej linii.",
        "Set up your payment provider": "Podepnij swój system płatności",
        "Drag and drop elements here": "Przeciągnij i upuść tutaj element",
        "Setup": "Ustawienia",
        "Source url": "Link do źródła",
        "Sign up": "Załóż konto",
        "Sign up for free": "Załóż darmowe konto",
        "Sign up now": "Zarejestruj się",
        "Simple way to sell": "Prosty sposób na",
        "your online courses": "sprzedaż kursów online",
        "We have designed Skyier with you and your students in mind. It is going to be a joy to create your site and a pleasure to learn from it.": "Skup się na tym, co pchnie Twój biznes do przodu. Skyier jest po to, aby Ci to ułatwić. Zajmiemy się hostingiem, aktualizacjami, usprawnieniami i rozwijaniem platformy.",
        "Skyier fees": "Całkowita prowizja pobrana przez Skyier",
        "Start selling": "Zacznij sprzedawać",
        "Start subscription": "Rozpocznij subskrypcję",
        "State": "Województwo",
        "Students": "Studenci",
        "Students Email": "E-mail studenta",
        "Students are not able to log in yet": "Studenci nie mogą jeszcze zakupić kursów",
        "Subscribe": "Subskrybuj",
        "Subscription": "Subskrypcja",
        "Subscription status": "Status subskrypcji",
        "Success": "Sukces",
        "Sum": "Suma",
        "TO DO": "DO ZROBIENIA",
        "Terms": "Regulamin",
        "Terms of Use": "Regulamin",
        "Thank you! You made our day!": "Dziękujemy! Dzięki Tobie nasz dzień jest piękniejszy!",
        "The currency your students will use to pay for the courses.": "Waluta, w jakiej studenci będą opłacali kursy.",
        "There was an error during the payment process. Please reload the page and try again.": "Wystąpił problem w czasie przetwarzania płatności. Proszę przeładuj stronę i spróbuj ponownie.",
        "Is free": "Darmowy",
        "This email will be publicly available.": "E-mail będzie dostępny publicznie na stronie.",
        "This episode is free to watch": "Lekcja jest darmowa",
        "This website uses cookies to ensure you get the best experience on our website.": "Używamy plików cookie, aby pomóc w personalizacji treści oraz zapewnić bezpieczne korzystanie z serwisu.",
        "Title": "Tytuł",
        "Title here": "Tutaj dodaj tytuł",
        "Total length": "Czas trwania wszystkich kursów online",
        "Total sale": "Łączna wartość ze sprzedaży kursów",
        "Transactions": "Transakcje",
        "Type": "Rodzaj",
        "Unlimited courses": "Nieograniczona liczba kursów",
        "Unlimited hosting": "Nieograniczony hosting",
        "Unlimited students": "Nieograniczona liczba studentów",
        "Unlimited videos": "Nieograniczona liczba wideo",
        "Unpublish": "Odpublikuj",
        "Upload content": "Dodaj szkolenie online",
        "Upload successfull. You can save your episode now.": "Wideo zostało załadowane. Możesz zapisać lekcję.",
        "Upload video": "Załaduj wideo",
        "Uploading": "Ładowanie w toku",
        "Vat number / Tax id": "NIP",
        "Watch episode": "Objrzyj lekcję",
        "Watch this course for": "Obejrzyj ten kurs za",
        "We are checking the redirection settings and installing a free SSL certificate for you. It may take up to 24 hours.": "Sprawdzamy poprawność ustawienienia przekierowania i instalujemy bezpłatny certyfikat SSL. Prace mogą potrwać do 24 godzin.",
        "We only make money when you make money. Our goals are alligned.": "Zarabiamy tylko wtedy, kiedy Ty zarabiasz. Nasze cele są spójne.",
        "We will send you additional information to your email address.": "Wyślemy dodatkowe informacje na adres e-mail.",
        "Withdraw": "Zleć wypłatę",
        "Withdrawal information": "Informacje do wypłaty środków",
        "Withdrawals": "Wypłaty",
        "Wróć do kursu": "Go back to the course",
        "Yes": "Tak",
        "You have no access to this lecture": "Niestety nie masz dostępu do kursu online. Ale możesz to zmienić!",
        "You need to set up your bank account before making withdrawals": "Zanim zlecisz wypłatę - musisz podać numer konta bankowego w ustawieniach konta.",
        "You need to set up your page settings before visiting your balance page": "Zanim wejdziesz na stronę z blilansem konta, musisz zakończyć ustawienia swojej strony z kursem",
        "You need to start uploading the video before saving the episode.": "Musisz załadować wideo zanim zapiszesz lekcję.",
        "Your current plan": "Twój obecny plan",
        "Your page is live:": "Twoja strona już jest dostępna:",
        "Your preffered currency to pay for your Skyier subscription.": "Waluta, w jakiej chcesz opłacać subskrypcję za Skyier.",
        "Your withdrawal is now pending. You will receive your payment once the system processes everything": "Zlecenie wypłaty zostało zaakceptowane. Środki finansowe pojawią się na koncie w ciągu 7 dni.",
        "Your withdrawal sum after all fees": "Łączny zarobek po odjęciu kosztów",
        "advanced": "zaawansowany",
        "and": "oraz",
        "and start selling": "i zacznij sprzedawać",
        "begginer": "początkujący",
        "co-founder": "współzałożyciel",
        "episodes": "lekcji",
        "false": "nie",
        "intermediate": "średniozaawansowany",
        "month": "miesiąc",
        "months": "miesięcy",
        "Credit card payments -> API": "Płatności kartami -> API",
        "Access length": "Długość dostępu",
        "of content": "materiałów wideo",
        "plus $0,30 per transaction": "plus 1 zł za transakcję",
        "programmer and co-founder": "współzałożyciel i programista",
        "true": "tak",
        "verification": "w trakcie weryfikacji",
        "John": "Jan",
        "Smith": "Kowalski",
        "John Smith": "Jan Kowalski",
        "example: John Smith": "przykład: Jan Kowalski",
        "Street, 12345 City, Country": "Ulica, 12-345 Miasto, Kraj",
        "VAT EU / TIN": "NIP",
        "12345 ": "12-345",
        "Digest algorithm": "Algorytm podpisu",
        "Public RSA Key": "Klucz publiczny RSA",
        "Verification Code": "Kod weryfikacyjny",
        "API Password": "Hasło API",
        "API Public Key": "Publiczny klucz API",
        "API Login": "Login API",
        "This file has to be an image.": "Plik musi mieć format obrazka.",
        "Recommended size: 600px width, 600px height.": "Zalacane wymiary: 600px szerokości, 600px wysokości.",
        "Provide a valid card number.": "Wprowadź poprawny numer karty.",
        "Provide a valid card expiration year.": "Wprowadź poprawny rok ważności karty.",
        "Provide a valid card expiration month.": "Wprowadź poprawny miesiąc ważności karty.",
        "Provide a valid CVV.": "Wprowadź poprawny kod CVV.",
        "Paylane or Braintree. If you need anything else - let us know :)": "Paylane lub Braintree. Jeśli potrzebujesz czegoś innego - daj nam znać :)",
        "Provide a valid name.": "Wprowadź poprawne imię i nazwisko.",
        "Provide a valid email address.": "Wprowadź poprawny adres e-mail",
        "Cancel subscription": "Anuluj subskrypcję",
        "Type CANCEL to confirm.": "Wpisz CANCEL, aby zatwierdzić anulowanie subskrypcji.",
        "Pay using": "Zapłać z",
        "Duplicate": "Duplikuj",
        "Target course id:": "Id kursu docelowego:",
        "attempt:": "wystaw",
        "Attempt": "Wystaw",
        "Started": "Rozpoczęto",
        "Completed": "Zakończono",
        "Next charge": "Następne pobranie opłaty",
        "Learning platform access extension": "Przedłużenie dostępu do platformy",
        "All": "Wszystko",
        "Membership": "Subskrypcja",
        "Membership trial": "Subskrypcja trial",
        "Membership model": "Model subskrypcyjny",
        "Membership settings": "Ustawienia subskrypcji",
        "One time payment model": "Jednorazowe płatności",
        "Subscribe to watch": "Subskrybuj, aby oglądać",
        "Required for membership payment processing": "Wymagane do modelu subskrypcyjnego:",
        "* Tpay is only avaliable in subscription model": "* Tpay jest dostępny tylko w modelu subskrypcyjnym",
        "Membership model lets you sell your courses as a subscription. Works only with selected payment providers.": "Model subskrypcyjny umożliwia sprzedaż kursów w planie abonamentowym. Działa tylko z wybranymi dostawcami bramek płatniczych.",
        "Options": "Opcje",
        "Membership options": "Opcje planów",
        "File too big": "Plik jest zbyt duży",
        "Performed": "Zakończone",
        "Preview shows all lectures (published and drafts)": "Podgląd pokazuje wszystkie lekcje (opublikowane i szkice)",
        "Payment model": "Model pobierania płatności",
        "Watch your course now": "Przejdź do oglądania kursu",
        "Payment successful": "Płatność została zrealizowana",
        "Recommended size: 1280px width, 800px height.": "Zalecany rozmiar: 1280px szerokości, 800px wysokości.",
        "Simple tool for selling online courses Skyier": "Platforma do kursów online Skyier",
        "Optimized images.": "Obrazy powinny być zoptymalizowane.",
        "This curse is free": "Ten kurs jest darmowy",
        "Start learning": "Rozpocznij naukę",
        "Start watching": "Rozpocznij naukę",
        "Max size: {size} MB": "Rozmiar maksymalny: {size} MB",
        "Thank you for your payment. You can watch your course now!": "Dziękuje za dokonanie płatnośći. Możesz teraz zacząć naukę!",
        "Benefits": "Korzyści",
        "Student access management": "Zarządzanie dostępem do kursów",
        "Video upload": "Wgrywanie wideo",
        "Features": "Funkcje",
        "Optimized Hosting": "Zoptymalizowany hosting",
        "Skyier hosts your course content and all the student data for you.": "Skyier przechowuje Twoje kursy i wszystkie dane studentów.",
        "Data Ownership": "Własność danych",
        "You own and control all of the content and student data.": "Ty jesteś właścicielem danych. Masz nad nimi pełną kontrolę możesz zarządzać w dowolny sposób.",
        "Updates and Improvements": "Aktualizacje i usprawnienia",
        "You will automatically receive the latest features. No manual updates.": "Wszystkie aktualizacje odbywają się automatycznie. Każda nowa funkcjonalność natychmiast pojawi się na Twoim koncie.",
        "SSL Certificate": "Certyfikat SSL",
        "A 2048-bit SSL certificate keeps your students' information secure during login and checkout.": "2048 bitowy certyfikat SSL czuwa nad bezpieczeństwem danych zakupowych Twoich studentów.",
        "Secured Payment Data": "Bezpieczne metody płatności",
        "You can integrate with Paylane, PayU, PayPal, Braintree. PCI level-1 compliant payment providers, so you and your users’ data is safe and secure.": "Współpracujemy tylko z systemami płatności spełniającymi wymogi PCI poziomu pierwszego. Wszystko po to, aby dane Twoich studentów były bezpieczne.",
        "SEO and SEM Optimized": "Strony zoptymalizowane pod SEO i SEM",
        "Your page is going to be optimized for great performance and conversion. You do not have to think about it.": "Twoja strona jest zoptymalizowana pod SEO, SEM i konwersję. Będziesz mógł sam to sprawdzić za pomocą Google Lighthouse lub innego narzędzia.",
        "This field is required": "Pole wymagane",
        "Instant updates": "Aktualizacje",
        "Check if all fields marked with  *  have been completed.": "Sprawdź, czy wszystkie pola oznaczone  *  zostały uzupełnione.",
        "Speed and conversion optimized": "Strony technicznie zoptymalizowane pod konwersje",
        "Every site created with Skyier is responsive and optimized to load as fast as possible. This way, your site is going to be faster than 97% of other sites. Your students and Google are going to love this.": "Zadbaliśmy m.in. o responsywność i prędkość ładowania się strony. Dzięki temu, Twoja strona jest szybsza niż 97% stron w internecie. I co ważne, przyjazna dla Google i Twoich klientów.",
        "Log in into your domain admin panel.": "Zaloguj się do swojego panelu zarządzania domeną.",
        "Find domain DNS records settings.": "Znajdź ustawienia rekordów DNS.",
        "Create a CNAME record for your domain. Depending on your domain provider, it should look like this:": "Dodaj rekord CNAME dla Twojej domeny. W zależności od panelu administracyjnego, powinien on wyglądać mniej więcej tak:",
        "Make sure correct domain is specified inside your": "Upewnij się, że dodałeś poprawną domenę do ",
        "page settings": "Ustawień strony",
        "Wait for the verification and SSL instalation.": "Zaczekaj na weryfikację domeny i instalację darmowego certyfikatu SSL.",
        "Contact us whenever you need any help redirecting your domain. We will be happy to help.": "Jeśli będziesz miał jakieś problemy, skontaktuj się z nami. Bardzo chętnie pomożemy.",
        "Instructions": "Instrukcje",
        "By using this website, you agree to our": "Ta strona korzysta z plików cookie. Aby dowiedzieć się więcej zapoznaj się z",
        "By using Skyier, you agree to our": "Ta strona korzysta z plików cookie. Aby dowiedzieć się więcej zapoznaj się z",
        "Cookie Policy": "Polityką Cookies",
        "Accept": "Akceptuj",
        "Plan contains": "Plan zawiera",
        "Free and paid courses": "Dodawanie kursów płatnych i darmowych",
        "Translations support": "Wsparcie dla wielu języków",
        "Polish": "Polski",
        "Polish or English. If you want more - contact us": "Teraz jest możliwość stworzenia strony w języku polskim lub angielskim. Jeśli interesuje Cię inny język - napisz do nas",
        "Invoicing system integrations": "Integracje z systemami do fakturowania",
        "iFirma, InFakt, Fakturownia. If you want more - contact us.": "iFirma, InFakt, Fakturownia. Jeśli interesuje Cię inny, napisz do nas",
        "JavaScript integration": "Dodawanie kodów JavaScript",
        "Install Google Analytics or other JavaScript codes": "Możliwość podpięcia kodu Google Analytics i innego kodu JavaScript",
        "Test before you pay": "Wypróbuj zanim zapłacisz",
        "What can I do with webhooks?": "Po co mi te webhooks?",
        "Webhooks allow you to automate your workflow.": "Możesz użyć Webhooks do zautomatyzowania przepływu pracy.",
        "Example:": "Przykład:",
        "You want to send a personal THANK YOU message when one of your students pay for a course.": "Chcesz wysłać spersonalizowaną wiadomość e-mail do studenta, który kupił Twój kurs.",
        "Just send a webhook to Zapier Webhooks and then integrate with anything you want from there.": "Wysłać webhook do Zapier Webhook, a następnie zintegrować się z czym chcesz. To naprawdę jest proste!",
        "Integrations": "Integracje",
        "Add webhook": "Dodaj webhook",
        "Add integration": "Dodaj integrację",
        "When such event occurs:": "Kiedy wystąpi następujące zdarzenie:",
        "Send event data to this url:": "Dane powinny zostać wysłane na adres url:",
        "Student has paid for a course": "Student zapłacił za kurs",
        "Student has registered": "Student zarejestrował się do platformy",
        "With <script></script> tags. Example: Google Tag Manager": "Skrypt musi zawierać tagi <script></script>. Możesz to wykorzystać do wklejenia kodu Google Tag Manager.",
        "JavaScript code": "Kod JavaScript",
        "Choose integration": "Wybierz integrację",
        "Api Key": "Klucz API",
        "User name": "Nazwa użytkownika",
        "What can I do with integrations?": "Po co mi te integracje?",
        "Integrations allow you to automate your workflow.": "Integracje umożliwą Ci zautomatyzowanie przepływu pracy.",
        "You want to create and send an invoice when one of your students pay for a course.": "Chcesz wystawić i wysłać fakturę dla studenta, który kupił Twój kurs. W tym celu integrujesz się ze swoim systemem do księgowania.",
        "Event": "Zdarzenie",
        "Invoice problem": "Problem z wystawieniem faktury",
        "You need to create your page first": "Aby móc dodać Webhook stwórz najpierw swoją stronę",
        "Webhook created": "Webhook został stworzony poprawnie",
        "Webhook deleted": "Webhook został usunięty",
        "Webhook test scheduled": "Test Webhook został dodany do kolejki",
        "You already have such integration": "Masz już dodaną taką integrację",
        "Integration created": "Integracja została stworzona poprawnie",
        "Integration deleted": "Integracja została usunięta",
        "Show more": "Pokaż więcej",
        "Show less": "Pokaż mniej",
        "Sales Volume": "Suma sprzedaży",
        "Last {num} days": "Ostatnie {num} dni",
        "Lecture list": "Lista lekcji",
        "iFirma -> Tools -> API -> Basic Auth keys -> faktura": "iFirma -> Narzędzia -> API -> Podstawowe klucze autoryzacji -> faktura",
        "Usually - your email address": "Zazwyczaj jest to adres email",
        "inFakt -> Settings -> API": "inFakt -> Ustawienia -> API",
        "Course settings have priority over episode settings": "Ustawienia kursu mają priorytet nad ustawieniami lekcji.",
        "This course is available only after log in": "Wymagane zalogowanie, aby obejrzeć za darmo",
        "I am happy to see you are interested": "Cieszę się, że chcesz obejrzeć ten kurs online!",
        "This course is free, log in to see the content": "Kurs jest darmowy. Zaloguj się, aby otrzymać dostęp",
        "This lecture is free, log in to see the content": "Lekcja jest darmowa. Zaloguj się, aby otrzymać dostęp",
        "This code only fires when student completes payment.": "Ten kod uruchomi się tylko gdy student dokona płatności.",
        "JavaScript Conversion Code": "JavaScriptowy kod konwersji",
        "Please remember to complete the transaction process. Make sure you are redirected back to the platform once the transaction is completed": "Pamiętaj, aby przejść przez cały proces transakcji. Jeśli po dokonaniu płatności bank nie przekieruje Cię automatycznie na stronę z kursem. Kliknij w przycisk \"Wróć do platformy\"",
        "Exempt from VAT": "Zwolniony z VAT",
        "Template name": "Nazwa szablonu",
        "Leave blank if you want to use the default one": "Pozostaw puste jeśli chcesz używać domyślnego szablonu",
        "Pattern: 12-345": "Wymagany format: 12-345",
        "Step 1 / 2": "Krok 1 / 2",
        "Step 2 / 2": "Krok 2 / 2",
        "Create course": "Dodaj kurs",
        "Create episode": "Dodaj lekcję",
        "retry": "spróbuj ponownie",
        "Invoice Status": "Status faktury",
        "Transaction Status": "Status transakcji",
        "Editor Guide": "Wskazówki z obsługi edytora",
        "You can use HTML inside course description. Please remember that bad html code can break your site.": "Możesz dodawać kod HMTL w opisie kursu. Pamiętaj, że źle dodany kod może zepsuć Twoją stronę. Sprawdzaj czy wszystkie znaczniki kodu <> są zamknięte.",
        "Emphasis": "Style czcionek",
        "bold": "pogrubienie",
        "italics": "kursywa",
        "strikethrough": "przekreślenie",
        "Headers": "Nagłówki",
        "Lists": "Listy",
        "Generic list item": "Element listy wypunktowanej",
        "Numbered list item": "Element listy numerycznej",
        "Images": "Obrazy",
        "Links": "Linki",
        "Text to display": "Tytuł obrazka",
        "Utilities": "Inne",
        "Horizontal ruler": "Linia oddzielająca",
        "Breaking space": "Odstęp między wierszami",
        "Student details": "Dane studenta",
        "Access": "Dostęp",
        "Action": "Działanie",
        "TRUE": "PRAWDA",
        "FALSE": "FAŁSZ",
        "Deny access": "Zabierz dostęp",
        "Allow access": "Przyznaj dostęp",
        "Reason?": "Powód?",
        "Type a reason behind this action for future reference.": "Wpisz powód wprowadzenia zmian, abyś o nim nie zapomniał.",
        "See all Transactions": "Zobacz wszystkie transakcje",
        "Access granted": "Dostęp został przyznany",
        "Access denied": "Dostęp został odebrany",
        "Articles link": "Nazwa strony z artykułami",
        "Articles feature": "Dodawanie artykułów",
        "Author details": "Dane autora",
        "Legal": "Informacje prawne",
        "Articles": "Artykuły",
        "example: blog": "przykład: blog",
        "Create article": "Dodaj artykuł",
        "Article": "Artykuł",
        "Body": "Treść",
        "Body here": "Treść dodaj tutaj",
        "Author": "Autor",
        "Author here": "Imię i nazwisko autora",
        "Publication settings": "Ustawienia publikacji",
        "Published at": "Opublikowany dnia:",
        "Add article": "Dodaj artykuł",
        "Article created": "Artykuł został zapisany",
        "Article updated": "Artykuł został zaktualizowany",
        "Article deleted": "Artykuł został usunięty",
        "min read": "min czytania",
        "Photos": "Zdjęcia",
        "See all": "Więcej",
        "Edit article": "Edytuj artykuł",
        "Cookie Preferences": "Ustawienia plików cookie",
        "We use cookies to enhance your browsing experience, serve personalised ads or content, and analyse our traffic. You can choose which categories to allow.": "Używamy plików cookie, aby poprawić komfort przeglądania, wyświetlać spersonalizowane reklamy lub treści oraz analizować nasz ruch. Możesz wybrać, które kategorie chcesz zezwolić.",
        "Accept All": "Akceptuj wszystkie",
        "Reject": "Odrzuć",
        "Customize": "Dostosuj",
        "Save Preferences": "Zapisz ustawienia",
        "Always on": "Zawsze włączone",
        "Necessary": "Niezbędne",
        "Essential for the website to function. These cookies cannot be disabled.": "Niezbędne do działania strony. Tych plików cookie nie można wyłączyć.",
        "Help us understand how visitors interact with the website by collecting and reporting information anonymously.": "Pomagają nam zrozumieć, w jaki sposób odwiedzający korzystają ze strony, zbierając i raportując informacje anonimowo.",
        "Marketing": "Marketingowe",
        "Used to deliver relevant advertisements and track the effectiveness of ad campaigns.": "Służą do wyświetlania trafnych reklam i śledzenia skuteczności kampanii reklamowych.",
        "Today": "Dziś",
        "Tomorrow": "Jutro",
        "(optional)": "(opcjonalnie)",
        "Actions": "Akcje",
        "Add a guest instead": "Dodaj gościa",
        "Add a window": "Dodaj przedział",
        "Add booking": "Dodaj rezerwację",
        "Add override": "Dodaj wyjątek",
        "All day": "Cały dzień",
        "All statuses": "Wszystkie statusy",
        "All upcoming bookings are already synced.": "Wszystkie nadchodzące rezerwacje są już zsynchronizowane.",
        "Availability": "Dostępność",
        "Availability overrides": "Wyjątki w dostępności",
        "Available": "Dostępny",
        "Block time off (vacation, holidays, a single afternoon) or open extra slots on top of the weekly availability.": "Zablokuj termin (urlop, święta, pojedyncze popołudnie) lub otwórz dodatkowe przedziały ponad tygodniową dostępnością.",
        "Blocked": "Zablokowany",
        "Booking": "Rezerwacja",
        "Bookings": "Rezerwacje",
        "Buffer between bookings (minutes)": "Bufor między rezerwacjami (minuty)",
        "Calendar": "Kalendarz",
        "Calendar name": "Nazwa kalendarza",
        "Calendars": "Kalendarze",
        "Canceled": "Anulowana",
        "Cancelled": "Anulowana",
        "Choose a calendar…": "Wybierz kalendarz…",
        "Clear all": "Wyczyść wszystko",
        "Client notes": "Notatki o kliencie",
        "Confirmed": "Potwierdzona",
        "Connect Google": "Połącz z Google",
        "Connect your Google account to create a Google Meet link for every booking and store it in the calendar.": "Połącz swoje konto Google, aby tworzyć link Google Meet dla każdej rezerwacji i zapisywać go w kalendarzu.",
        "Connected": "Połączono",
        "Copy this day to every day": "Skopiuj ten dzień na wszystkie dni",
        "Could not save the availability. Please try again.": "Nie udało się zapisać dostępności. Spróbuj ponownie.",
        "Could not save the booking. Please try again.": "Nie udało się zapisać rezerwacji. Spróbuj ponownie.",
        "Could not save the overrides. Please try again.": "Nie udało się zapisać wyjątków. Spróbuj ponownie.",
        "Create a Google Meet for every upcoming confirmed booking?": "Utworzyć Google Meet dla każdej nadchodzącej potwierdzonej rezerwacji?",
        "Create meeting": "Utwórz spotkanie",
        "Danger zone": "Strefa niebezpieczna",
        "Day": "Dzień",
        "Deleting a calendar permanently removes its bookings, availability and Google connection.": "Usunięcie kalendarza trwale usuwa jego rezerwacje, dostępność i połączenie z Google.",
        "Discard": "Odrzuć",
        "Disconnect": "Odłącz",
        "Disconnect Google? Existing meeting links are kept.": "Odłączyć Google? Istniejące linki do spotkań zostaną zachowane.",
        "Ends": "Koniec",
        "Extra availability": "Dodatkowa dostępność",
        "Filter bookings": "Filtruj rezerwacje",
        "Free time kept between two consecutive bookings.": "Czas wolny między dwiema kolejnymi rezerwacjami.",
        "Google": "Google",
        "Google Calendar": "Kalendarz Google",
        "Google is not configured on this server. Set GOOGLE_CLIENT_ID and GOOGLE_CLIENT_SECRET in .env first.": "Google nie jest skonfigurowany na tym serwerze. Najpierw ustaw GOOGLE_CLIENT_ID i GOOGLE_CLIENT_SECRET w pliku .env.",
        "Guest": "Gość",
        "Has notes": "Z notatkami",
        "Hours": "Godziny",
        "Loading bookings…": "Wczytywanie rezerwacji…",
        "Manage booking": "Zarządzaj rezerwacją",
        "Meeting link": "Link do spotkania",
        "Navigation": "Nawigacja",
        "No booking matches the filters.": "Żadna rezerwacja nie pasuje do filtrów.",
        "No bookings in this calendar yet.": "Ten kalendarz nie ma jeszcze rezerwacji.",
        "No course matches - you can leave this empty.": "Brak pasującego kursu - możesz pozostawić puste.",
        "No overrides yet - the weekly availability applies as-is.": "Brak wyjątków - obowiązuje tygodniowa dostępność.",
        "No student matches.": "Brak pasującego kursanta.",
        "No upcoming bookings": "Brak nadchodzących rezerwacji",
        "No upcoming overrides": "Brak nadchodzących wyjątków",
        "No-show": "Nieobecność",
        "Not connected": "Nie połączono",
        "Nothing upcoming": "Brak nadchodzących",
        "Open": "Otwórz",
        "Overrides": "Wyjątki",
        "Partial-day overrides must start and end on the same day.": "Wyjątki częściowe muszą zaczynać się i kończyć tego samego dnia.",
        "Pending": "Oczekująca",
        "Pick a date and time": "Wybierz datę i godzinę",
        "Presets": "Ustawienia wstępne",
        "Reason": "Powód",
        "Reason (optional)": "Powód (opcjonalnie)",
        "Remove": "Usuń",
        "Remove this booking?": "Usunąć tę rezerwację?",
        "Search by name or email": "Szukaj po imieniu lub e-mailu",
        "Search by title": "Szukaj po tytule",
        "Search for a student instead": "Zamiast tego wyszukaj kursanta",
        "Searching…": "Wyszukiwanie…",
        "Something went wrong. Please try again.": "Coś poszło nie tak. Spróbuj ponownie.",
        "Starts": "Początek",
        "Status": "Status",
        "Student": "Kursant",
        "Sync all upcoming": "Synchronizuj wszystkie nadchodzące",
        "Target Google Calendar": "Docelowy kalendarz Google",
        "Time zone": "Strefa czasowa",
        "Times are in": "Czasy w strefie",
        "Timezone": "Strefa czasowa",
        "To": "Do",
        "Type a name or an email to search.": "Wpisz imię lub adres e-mail, aby wyszukać.",
        "Type a title to search.": "Wpisz tytuł, aby wyszukać.",
        "Type the calendar name to confirm:": "Wpisz nazwę kalendarza, aby potwierdzić:",
        "Unavailable": "Niedostępny",
        "Unsaved changes": "Niezapisane zmiany",
        "Upcoming bookings without a meeting link": "Nadchodzące rezerwacje bez linku do spotkania",
        "View": "Widok",
        "Week": "Tydzień",
        "Weekly availability": "Tygodniowa dostępność",
        "When": "Kiedy",
        "Whole day": "Cały dzień",
        "a partial-day override must start and end on the same day": "wyjątek częściowy musi zaczynać się i kończyć tego samego dnia",
        "availability windows cannot overlap": "przedziały dostępności nie mogą się nakładać",
        "browser time": "czas przeglądarki",
        "calendar": "kalendarz",
        "canceled": "anulowana",
        "cancelled": "anulowana",
        "completed": "zakończona",
        "confirmed": "potwierdzona",
        "days per week": "dni w tygodniu",
        "end time": "godzina zakończenia",
        "enter a valid email": "wpisz prawidłowy adres e-mail",
        "enter the guest email": "wpisz adres e-mail gościa",
        "enter the guest name": "wpisz imię gościa",
        "h": "godz.",
        "min": "min",
        "more": "więcej",
        "no-show": "nieobecność",
        "or a guest": "lub gościa",
        "pending": "oczekująca",
        "per week": "w tygodniu",
        "pick a student or enter a guest name and email": "wybierz kursanta lub wpisz imię i adres e-mail gościa",
        "primary": "główny",
        "set a start": "ustaw początek",
        "set a start date": "ustaw datę początkową",
        "set an end": "ustaw koniec",
        "set an end date": "ustaw datę końcową",
        "set both a start and an end time": "ustaw godzinę rozpoczęcia i zakończenia",
        "shown": "wyświetlonych",
        "start time": "godzina rozpoczęcia",
        "the end date must be on or after the start date": "data zakończenia musi być taka sama lub późniejsza niż data rozpoczęcia",
        "the end must be after the start": "koniec musi być po początku",
        "the end time must be after the start time": "godzina zakończenia musi być po godzinie rozpoczęcia",
        "total": "łącznie",
        "upcoming": "nadchodzących",
        "passwords": {
            "password": "Hasło musi zawierać co najmniej 6 znaków.",
            "reset": "Hasło zostało zresetowane!",
            "sent": "Na podany adres e-mail ({email}) został wysłany link do resetu hasła.",
            "token": "Token resetu hasła jest błędny.",
            "user": "Nie możemy znaleźć takiego adresu e-mail w naszej bazie.",
            "spam": "W razie problemów, sprawdź folder \"SPAM\".",
            "check": "Upewnij się, że podany adres e-mail jest poprawny.",
            "checkemail": "Sprawdź swoją skrzynkę e-mail"
        },
        "auth": {
            "failed": "Podane dane są błędne.",
            "throttle": "Zbyt dużo prób logowania. Proszę spróbuj ponownie za {seconds} sekund."
        },
        "pagination": {
            "previous": "&laquo; Poprzednia",
            "next": "Następna &raquo;"
        },
        "validation": {
            "accepted": "{attribute} jest wymagany.",
            "active_url": "{attribute} to nie jest prawidłowy adres URL.",
            "after": "{attribute} musi być datą po {date}.",
            "after_or_equal": "{attribute} musi być datą równą lub dalszą niż {date}.",
            "alpha": "{attribute} może zawierać tylko litery.",
            "alpha_dash": "{attribute} może zawierać tylko litery, cyfry i ukośniki.",
            "alpha_num": "{attribute} może zawierać tylko litery i cyfry.",
            "array": "{attribute} musi być tablicą danych (array).",
            "before": "{attribute} musi być datą przed {date}.",
            "before_or_equal": "{attribute} musi być datą równą lub przed {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "Wartości nie są takie same.",
            "date": "Nieprawidłowa data.",
            "date_format": "Format daty nie jest zgodny z formatem {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "Musi zawierać {digits} cyfr.",
            "digits_between": "Musi zawierać od {min} do {max} cyfr.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "Podaj poprawny adres e-mail.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "Wymagane.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "Plik nie może być większy niż {max} KB.",
                "string": "Treść nie może mieć więcej niż {max} znaków.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "Wartość minimalna: {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "Minimum znaków: {min}.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "Wymagane",
            "required_if": "Wymagane",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} is present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "Plik nie może być większy niż {size} KB.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "string": "Wartość powinna być tekstem.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "Podana nazwa jest zajęta.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        },
        "my": {
            "on_the_page": "na stronie {url}",
            "membership": "{-1} Lifetime|{1} Miesięcznie|{3} Kwartalnie|{6} Półrocznie|{12} Rocznie",
            "memberships_active": "Aktywne",
            "memberships_at_risk": "Zagrożone",
            "memberships_canceled": "Anulowane",
            "memberships_finished": "Zakończone",
            "results": "rezultaty: {xx}",
            "your_comment_length": "Twój komentarz: {length} znaków",
            "character_limit": "Maksymalnie: {limit} znaków",
            "no_time": "Brak czasu na korzystanie",
            "no_value": "Nie uzyskałem/am odpowiednio dużej wartości",
            "other": "Inny powód",
            "expensive": "Zbyt wysoka cena",
            "technical": "Problemy techniczne",
            "alternative": "Znalazłem/am lepszą alternatywę",
            "definitely_return": "Zdecydowanie tak",
            "maybe_return": "Raczej tak",
            "probably_not_return": "Prawdopodobnie nie",
            "never_return": "Zdecydowanie nie",
            "waitx": "Poczekaj {x} s na ponowne wysłanie"
        }
    }
}
